const VERIFY_CUSTOMER_EMAIL_API_URL = 'https://phpstack-1018833-4127515.cloudwaysapps.com/checkcustomerglo.php';

document.addEventListener('alpine:init', () => {

  Alpine.directive('uncloak', (el) => {
    // hide element after Alpine initializes
    queueMicrotask(() => el.style.display = 'none');
  });

  // handle pill buttons action
  Alpine.data('pillButtons', () => ({
    init() {
      // Check if the URL has the filter.p.product_type parameter
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has('filter.p.product_type')) {
        // If not present, clear the selected pill button data
        window.sessionStorage.removeItem('LIF-PARAM--SELECTED_PILL_BUTTON');
      }

      window.sessionStorage.setItem('LIF-PARAM--CURRENT_PAGE_URL', window.location.href);
    },
    filter(productTypes, index) {
      window.sessionStorage.setItem('LIF-PARAM--SELECTED_PILL_BUTTON', index);

      let queryString = "?filter.p.product_type=" + productTypes;

      const existingParams = window.location.search.substring(1).split('&'); // Includes the "?" character
      if (existingParams.length > 0) {
        for(const param of existingParams) {
          if (!param.startsWith('sort_by=') && !param.startsWith('filter.')) {
            queryString += "&" + param;
          }
        }
      }
      
      window.location.href = queryString;
    },
    get selectedPillButtonIndex() {
      return window.sessionStorage.getItem('LIF-PARAM--SELECTED_PILL_BUTTON');
    }
  }));

  Alpine.data('collectionFilter', () => ({
    fllterOpen: false,
    totalResultCount: null,
    selectedSortBy: null,
    selectedSortByName: "Featured",
    showFilterModal: false,
    selectedFilterNames: [],
    priceFilterValues: [],
    filterIsInProgress: false,
    timer: null,
    controller: null,

    debouncedSearch(formRef = null, removeFilter = null) {
      clearTimeout(this.timer);

      // cancel previous request
      if (this.controller) {
        this.controller.abort();
      }

      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.timer = setTimeout(() => {
        this.applyFilter(formRef, removeFilter, signal);
      }, 500);
    },

    init() {

      this.updateProductCount();
      
      Alpine.store('URL').queryParams.forEach((param) => {
        if (param[0] == 'sort_by') {
          this.selectedSortBy = param[1];

          if (this.selectedSortBy == 'price-ascending' || this.selectedSortBy == 'price-descending') {
            this.loadAllPages(() => {
              setTimeout(() => {
                // Sort by client side
                this.orderTilesByPrice();  
              }, 2000); // Let's load price element
            });
          }
        }
      });

      this.$watch('fllterOpen', (isOpen) => {
        console.log('fllterOpen changed...');
        console.log(isOpen);
        Alpine.store('screen').isScrollableBody = !isOpen;
      }); 

      Alpine.nextTick(() => {
        // Reinitialize Alpine refs and behaviors if needed
        this.updateSelectedFilterNames();
      });
    },

    updateSelectedFilterNames() {
      Alpine.initTree(document.querySelector('#filter_flyout'));
      this.selectedFilterNames = [];

      // Re-select the form after DOM has been updated
      const filterForm = document.querySelector('[x-ref="filterForm"]');
      if (!filterForm) return;

      const checkedFilters = filterForm.querySelectorAll('input[type="checkbox"]:checked');
      checkedFilters.forEach((input) => {
        const label = input.nextElementSibling?.innerText.trim() || input.dataset.label.trim() || input.value.trim();
        this.selectedFilterNames.push({ 
          label,
          data: {
            name: input.name, 
            value: input.value 
          }
        });
      });

      const params = new URLSearchParams(window.location.search);
      const paramMinPrice = params.get('filter.v.price.gte');
      const paramMaxPrice = params.get('filter.v.price.lte');

      if (paramMinPrice && paramMaxPrice) {
        this.selectedFilterNames.push({ 
          label: `Price: Min ${paramMinPrice}, Max ${paramMaxPrice}`,
          data: { name: 'price',  value: '' }
        });
      }

      // Default values are full range
      this.priceFilterValues = (paramMinPrice && paramMaxPrice) ? [paramMinPrice, paramMaxPrice] : [minPrice, maxPrice];


      console.log(this.selectedFilterNames);
    },

    updateProductCount() {
      this.totalResultCount = null;
      // fetch total customized product count
      const urlConnector = window.location.href.includes('?') ? '&' : '?';
      fetch(window.location.href+urlConnector+'view=products-count')
      .then(response => response.text())
      .then(count => {
        this.totalResultCount = parseInt(count.trim());
      })
    },

    async applyFilter(formRef = null, removeFilter = null, signal = null) {
      
      // console.log('applyFilter...');
      // this.$refs.filterForm.submit();

      try {
        let formData = new FormData(formRef ? this.$refs[formRef] : this.$refs.filterForm);

        // if (!this.$refs.filterForm && !this.$refs.filterForm) {
        //   const filterForm = document.querySelector('[x-ref="filterForm"]');
        //   formData = new FormData(filterForm)
        // }

        // Convert to a query string
        const searchParams = new URLSearchParams(formData);
        const uniqueSearchParams = {};

        for (const [key, value] of searchParams) {

          console.log(removeFilter);

          // check if filter to remove
          if (removeFilter && (removeFilter.name == 'ALL' || (removeFilter.name == 'price' && key.includes('filter.v.price.')) || (key == removeFilter.name && value == removeFilter.value))) {
            // Skip filter to remove
            continue;
          }

          if (uniqueSearchParams.hasOwnProperty(key)) {
            // Make comma seperated muitlple values
            uniqueSearchParams[key] = `${uniqueSearchParams[key]},${value}`;
          } else {
            uniqueSearchParams[key] = value;
          }
        }

        this.selectedSortBy = uniqueSearchParams.sort_by;
        const hasNewSort = Object.keys(uniqueSearchParams).includes('sort_by');
        const hasNewFilter = Object.keys(uniqueSearchParams).find(p => p.startsWith('filter.'));
        const hasEmptyFilter = Object.keys(uniqueSearchParams).length == 0;

        let queryString = Object.keys(uniqueSearchParams).map(k => `${k}=${uniqueSearchParams[k]}`).join('&');
        // console.log(queryString);

        const existingParams = window.location.search.substring(1).split('&'); // Includes the "?" character
        if (existingParams.length > 0) {
          for(const param of existingParams) {

            if (param.startsWith('page=')) {
              continue;
            }

            const hasExistingSort = param.startsWith('sort_by=');
            const hasExistingFilter = param.startsWith('filter.');

            if ((!hasExistingSort && !hasExistingFilter) || (hasExistingSort && !hasNewSort) || (hasExistingFilter && !hasNewFilter && !hasEmptyFilter)) {
              if (queryString) {
                queryString += "&" + param;
              } else {
                queryString = param;
              }
            }
          }
        }

        console.log(queryString);

        const baseURL = window.location.origin + window.location.pathname;
        const searchURL = `${baseURL}?${queryString}`;
        window.history.replaceState(queryString, document.title, searchURL);

        if (uniqueSearchParams.sort_by) {
          if (uniqueSearchParams.sort_by == 'price-ascending' || uniqueSearchParams.sort_by == 'price-descending') {

            this.selectedSortBy = uniqueSearchParams.sort_by;

            if (Alpine.store('collection').hasNextPage) {
              this.loadAllPages(() => {
                setTimeout(() => {
                  // Sort by client side
                  this.orderTilesByPrice();  
                }, 2000); // Let's load price element
              });
            } else {
              this.orderTilesByPrice();
            }

            return;
          }
        }

        this.updateProductCount();

        const response = await fetch(searchURL, { signal });
        const res = await response.text();

        // Initialize the DOM parser
        var parser = new DOMParser();

        // Parse the text
        const doc = parser.parseFromString(res, "text/html");

        // Fetch page content and pagination content from page result
        const newContainer = doc.querySelector('#product_grid');
        const newFilter = doc.querySelector('#filter_flyout');
        const newPagination = doc.querySelector('#product_pagination');
        const newTotalResult = doc.querySelector('#total_result_count');
        const newSorting = doc.querySelector('#sorting_flyout');

        // Render page content to end of the page
        if (newContainer) {

          const existingContainer = document.querySelector('#product_grid');

          const firstOrderProducts = document.querySelectorAll('.first-order-product');

          existingContainer.innerHTML = newContainer.innerHTML;
          document.querySelector('#collection_error_container').innerHTML = '';

          [...firstOrderProducts].reverse().forEach(firstOrderProduct => {

            const variantId = firstOrderProduct.dataset.variantId;

            // Check for duplication
            const duplicate = existingContainer.querySelector(
              `[data-variant-id="${variantId}"]`
            );

            // Remove duplicate if any
            if (duplicate) {
              duplicate.remove();
            }

            existingContainer.insertBefore(firstOrderProduct, existingContainer.firstChild);
          });

        } else {
          document.querySelector('#product_grid').innerHTML = '';
          document.querySelector('#collection_error_container').innerHTML = 'No products found. Use fewer filters or remove all.';
        }

        if (newFilter) {
          document.querySelector('#filter_flyout').innerHTML = newFilter.innerHTML;
        }

        if (newSorting) {
          document.querySelector('#sorting_flyout').innerHTML = newSorting.innerHTML;
        }

        if (newPagination) {
          document.querySelector('#product_pagination').innerHTML = newPagination.innerHTML;
        }

        // document.querySelectorAll('.collection__total-items').forEach((e) => {
        //   const totalResult = newTotalResult.innerHTML;
        //   const itemText = totalResult > 1 ? 'Items' : 'Item';
        //   e.innerHTML = `${totalResult} ${itemText}`;
        // });

        // this.totalResultCount = newTotalResult.innerHTML;
        Alpine.store('collection').hasNextPage = true;

        Alpine.store('collection').loadFirstProduct();

        // loadPages defined in products-pagination.js (calling parent method)

        if (this.loadPages) {
          this.currentPage = 1;
          this.loadPages(queryString);
        }

        Alpine.nextTick(() => {
          this.updateSelectedFilterNames();
        });

      } catch (e) {
        if (e.name === 'AbortError') {
          console.log('Request cancelled');
        } else {
          console.error(e);
        }
      }
    },

    getNumber(str) {
      return parseFloat(str.replace(/[^0-9-]/g, ""))
    },

    orderTilesByPrice() {
      const tileElements = document.querySelectorAll('li.collection-product-tile:not(.first-order-product)');
      for(const tileElement of tileElements) {
        const priceElement = tileElement.querySelector('.product-tile-price');
        if (priceElement) {
          const price = this.getNumber(priceElement.innerHTML);
          tileElement.style.order = this.selectedSortBy == 'price-descending' ? (-1) * price : price;
        }
      }
    }
  }));

  // Extending collectionFilter
  Alpine.data('explorationFilter', (activeMenuIndexes, minPrice, maxPrice) => ({
    openedFilterMenuIndexes: activeMenuIndexes,
  
    init() {

      const params = new URLSearchParams(window.location.search);
      const paramMinPrice = params.get('filter.v.price.gte');
      const paramMaxPrice = params.get('filter.v.price.lte');

      // Default values are full range
      this.priceFilterValues = (paramMinPrice && paramMaxPrice) ? [paramMinPrice, paramMaxPrice] : [minPrice, maxPrice];

      const priceSlider = this.$refs.price_slider;

      if (priceSlider) {
        noUiSlider.create(priceSlider, {
          start: this.priceFilterValues,
          connect: true,
          step: 1,
          range: {
            'min': minPrice,
            'max': maxPrice
          },
          tooltips: true,
          format: {
            to: function (value) {
              return Math.round(value);
            },
            from: function (value) {
              return Number(value);
            }
          }
        });

        const minPriceDisplay = document.getElementById("min-price");
        const maxPriceDisplay = document.getElementById("max-price");

        priceSlider.noUiSlider.on('update', (values) => {
          minPriceDisplay.textContent = values[0];
          maxPriceDisplay.textContent = values[1];
        });

        priceSlider.noUiSlider.on('change', (values) => {
          this.priceFilterValues = values;
        });
      }
    },

    toggleMenu(index) {
      if (this.openedFilterMenuIndexes.includes(index)) {
        const itemIndex = this.openedFilterMenuIndexes.indexOf(index);

        if (itemIndex > -1) {
          this.openedFilterMenuIndexes.splice(itemIndex, 1);
        }
      } else {
        this.openedFilterMenuIndexes.push(index);
      }
    },
    
  }));

  // Handle mobile - sticky add-to-cart button
  Alpine.data('stickyAddToCart', () => ({
    init() {
      window.addEventListener('scroll', this.handleScroll);
    },
    handleScroll() {
      const buyButtons = document.querySelector('.pdp-add-to-cart-button');
      const stickyButton = document.getElementById('sticky-add-to-cart');

      if (buyButtons) {
        const rect = buyButtons.getBoundingClientRect();

        if (rect.top < -buyButtons.offsetHeight && Alpine.store('cart').isSideCartOpen === false) {
          stickyButton.style.display = 'block'; // Show sticky button
        } else {
          stickyButton.style.display = 'none'; // Hide sticky button
        }
      }
    }
  }));

  Alpine.data('shopSimilar', () => ({
    showModal: false,
    products: [],
    product: null,
    hasProducts: true,

    init() {
      this.product = JSON.parse(document.getElementById('product-json').textContent);
      this.fetchProducts();
      this.fetchAndAppendImages();

      this.$watch('showModal', (isShow) => {
        Alpine.store('screen').isScrollableBody = !isShow;
      });
    },

    async fetchProducts() {
      const tags = this.product.tags;
      const styleGroupTag = tags.find(tag => tag.startsWith('_style-group::'));

      if (!styleGroupTag) {
        console.log('No style group tag found.');
        return;
      }

      // console.log('style group tag found.');
      // console.log(styleGroupTag);
      
      const styleGroupNumber = styleGroupTag.split('::')[1];
      try {
        const response = await fetch(`/collections/all/_style-group::${styleGroupNumber}?view=products_by_style_grid`);
        const data = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const productGrid = doc.querySelector('#product_grid');
        let countProducts = 0;

        if (productGrid) {
          const items = productGrid.querySelectorAll('li');
          const flickitySlider = this.$el.querySelector('.carousel');
          const mobileModal = this.$el.querySelector('.shop-similar-mobile-modal');
          
          if (items.length === 0) {
            this.hasProducts = false;
            return;
          }

          for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const titleElement = item.querySelector('.card-item-title');
            if (!titleElement) {
              continue; // Skip this iteration
            }

            const itemTitle = titleElement.innerHTML;

            if (this.product.title === itemTitle) {
              continue; // Skip this iteration
            }

            countProducts++;
            const tempContainer = document.createElement('div');
            // Create a temporary container
            tempContainer.innerHTML = item.innerHTML;

            // Select the second child element from tempContainer
            const secondChild = tempContainer.children[1];

            // If the second child exists, set it as the innerHTML of tempContainer
            if (secondChild) {
                tempContainer.innerHTML = secondChild.outerHTML;
            }

            // Now tempContainer contains only the second child
            const childElements = tempContainer.children; 

            Array.from(childElements).forEach(child => {
              child.style.width = '25%';
              child.style.marginRight = '0.5rem';
              flickitySlider.appendChild(child);
              let imgElement = child.querySelector("img.product-tile-image");

              // Add the 'w-auto' class to the image element
              if (imgElement) {
                imgElement.classList.add('!w-auto');
                imgElement.classList.add('!h-auto');
              }
            });

            const mobileItem = document.createElement('div');
            mobileItem.innerHTML = item.innerHTML;
            mobileModal.appendChild(mobileItem);
          }

          if (countProducts <= 4) {
            setTimeout(() => {
              new Flickity('.carousel', {
                fade: true,
                imagesLoaded: true,
                contain: true,
                pageDots: false,
                cellAlign: 'left',
                draggable: false,
                groupCells: false,
                wrapAround: false,
              });
            }, 50);
          } else {
            setTimeout(() => {
              new Flickity('.carousel', {
                fade: true,
                imagesLoaded: true,
                contain: true,
                pageDots: false,
                cellAlign: 'left',
                groupCells: false,
                wrapAround: false,
              });
            }, 50);
          }
          setTimeout(() => {
            if (countProducts <= 4) {
              // Hide Flickity navigation buttons
              const flickityButtons = flickitySlider.querySelectorAll('.flickity-button');
              flickityButtons.forEach(button => {
                button.classList.add('hidden');
              });
            }
          }, 100);      
        } else {
          this.hasProducts = false;
        }
        console.log('countProducts:', countProducts);
        if (countProducts === 0) {
          this.hasProducts = false;
          return;
        }
      } catch (error) {
        console.error('Error fetching the products:', error);
        this.hasProducts = false;
      }
    },

    async fetchAndAppendImages() {
      try {
        const tags = this.product.tags;
        const styleGroupTag = tags.find(tag => tag.startsWith('_style-group::'));

        if (!styleGroupTag) {
          console.log('No style group tag found.');
          this.hasProducts = false;
          return;
        }

        const styleGroupNumber = styleGroupTag.split('::')[1];
        const response = await fetch(`/collections/all/_style-group::${styleGroupNumber}?view=products_by_style_json`);
        const products = await response.json();
        const gridContainer = this.$el.querySelector('.gridContainer');
        let appendedCount = 0;

        if (products.length === 0) {
          this.hasProducts = false;
          return;
        }

        products.forEach(relatedProduct => {
          if (appendedCount >= 4) return;
          if (this.product.id === relatedProduct.id) return;

          if (relatedProduct.images && relatedProduct.images.length > 0) {
            const firstImage = relatedProduct.images[0];
            const imgElement = document.createElement('img');
            imgElement.setAttribute('src', firstImage.src);
            imgElement.setAttribute('alt', firstImage.alt || '');
            imgElement.setAttribute('width', firstImage.width || 100);
            imgElement.setAttribute('height', firstImage.height || 100);
            imgElement.classList.add('product-tile-image', 'relative', 'object-cover', 'aspect-square', 'cursor-pointer');
            gridContainer.appendChild(imgElement);
            appendedCount++;
          }
        });

        if (appendedCount === 0) {
          this.hasProducts = false;
        }
      } catch (error) {
        console.error('Error fetching or parsing the JSON data:', error);
        this.hasProducts = false;
      }
    },
  }));

  Alpine.data('productTile', (productHandle, cardIndex, atcRedirect, restrictPDP) => ({
    product: null,
    mainImage: null, 
    showSvg: false, 
    cardIndex: cardIndex, 
    showOptionSelection: false, 
    swiperInstance: null,
    hoverTriggered: false,
    // selectedColor: '', 
    // selectedSize: '',
    // selectedStyle: '',
    quickAddIndex: null,
    shouldProductImageShow: false,
    optionIndex: {},
    isProductDODLimt1: false,
    isSingleVariantProduct: false,
    selectedOptions: {},
    openSizeChart: false,
    selectedVariantColorCode: null,
    variantInverseColor: null,
    itemQty: 1,
    specialTagBadges: [],
    updateSelectedVariantURLState: false,
    onlyShowColorsAvailable: false,

    init() {
      // Instance load product 
      try {

        if (productHandle.product) {
          this.product = productHandle.product;
        } else if (this.fwpProduct) {
          this.product = this.fwpProduct;
        } else {
          this.product = JSON.parse(document.querySelector('#product_'+productHandle+'[type="application/json"]').textContent);
        }

        // Hide " - #" suffix from product titles of Kit products
        this.product.title = this.cleanKitProductTitle(this.product.title);

        for (option of this.product.options) {
          const optionName = option.name.toLowerCase();
          this.optionIndex[optionName] = option.position - 1;

          // Check if only one option value is available, then keep selected
          if (option.values.length == 1) {
            this.selectedOptions[option.position] = option.values[0];
          } else {
            this.selectedOptions[option.position] = null;
          }
        }

        // Set initial value of color
        // this.selectedColor = this.product.options[this.optionIndex.color] ? this.product.options[this.optionIndex.color].values[0] : null;

        if (this.optionIndex.color) {
          const colorIndex = this.optionIndex.color;
          this.selectedOptions[colorIndex + 1] = this.product.options[colorIndex].values[0];
        }

        // if (this.optionIndex.style !== undefined) {
        //   this.selectedStyle = this.product.options[this.optionIndex.style] ? this.product.options[this.optionIndex.style].values[0] : null;
        // }

        // if (this.selectedHoodieColor == 'null') {
        //   debugger;
        // }

        this.mainImage = this.product.image;
        // console.log('Product loaded: '+this.mainImage);
        
        this.isProductDODLimt1 = !!this.product.tags.find((t) => t.toLowerCase() == 'dod-limit-1');

        this.isSingleVariantProduct = this.product.options.length == 1 && this.product.variants.length == 1;

        // Select first available variant if fwpProduct popup
        if (this.fwpProduct) {
          const firstAvaibleVariant = this.product.variants.find(v => v.remaining_quantity > 0 || v.inventory_policy == 'continue');

          // Select this variant
          for(optionIndex of Object.keys(this.selectedOptions)) {
            this.selectedOptions[optionIndex] = firstAvaibleVariant[`option${optionIndex}`];
          }
        }

        // Auto-select the first available variant
        const firstAvailableVariant = this.product.variants.find(v => {
          // Check in cart item qty too
          const cartVariantItem = Alpine.store('cart').cartItems.find(i => i.variant_id == v.id);
          const cartVariantQty = cartVariantItem ? parseInt(cartVariantItem.quantity) : 0;

          return (v.remaining_quantity - cartVariantQty) > 0 || v.inventory_policy == 'continue'
        });

        // Check if variant id is passed via URL for PDP
        let selectedVariantParam = null;
        const { params } = Alpine.store('URL');
        if (params && params.variant) {
          selectedVariantParam = this.product.variants.find(v => v.id == params.variant);
        }

        let selectedVariant = selectedVariantParam ? selectedVariantParam : firstAvailableVariant;
        const positions = this.product.options.map(o => o.position);

        // console.log('selectedVariant:'+this.product.title);
        // console.log(selectedVariant);

        if (!selectedVariant) {
          selectedVariant = this.product.variants[0];
        }

        for (const position of positions) {
          this.selectedOptions[position] = selectedVariant[`option${position}`];
        }

        this.mainImage = selectedVariant.image;
      
        // set special tag badges
        if (window.__LIF__.special_product_badges) {
          this.specialTagBadges = window.__LIF__.special_product_badges.filter(b => this.product.tags.includes(b.product_tag));
        }

        // if (this.upsellProducts && this.selectedHoodieColor) {
        if (this.upsellProducts && this.selectedHoodieColor && this.selectedHoodieColor != 'null') {
          console.log('selectedHoodieColor: '+this.selectedHoodieColor);

          if (this.optionIndex.color || this.optionIndex.color === 0) {
            const colorOptionPosition = this.optionIndex.color + 1;
            let colorName = this.selectedHoodieColor.split("-").pop().trim();

            const colorOption = this.product.options.find(o => o.name.toLowerCase() == 'color');
            if (!colorOption.values.includes(colorName)) {
              colorName = colorOption.values.find(v => {
                const coreColorName = v.split("-").pop().trim();
                return (coreColorName == this.selectedHoodieColor || coreColorName == colorName)
              });
            }

            this.selectedOptions[colorOptionPosition] = colorName;

            const colorVariant = this.product.variants.find(v => v[`option${colorOptionPosition}`] == colorName);
            if (colorVariant) {
              this.mainImage = colorVariant.image;
            }
          }

          console.log(this.selectedOptions);
        }

      } catch(error) {
        console.error(error);
      };

      // Dynamic load product  -- Had performance issue
      // fetch(`/products/${productHandle}.json`)
      // .then((r) => r.json())
      // .then((r) => {
      //   this.product = r.product;
      //   this.selectedColor = this.product.options[1] ? this.product.options[1].values[0] : null;
      //   this.mainImage = this.product.image.src;
      // })
      // .catch((error) => {
      //   console.error(error);
      // });

      const onlyShowColorsAvailableParam = window.sessionStorage.getItem('LIF-PARAMS-onlyShowColorsAvailable');
      if (onlyShowColorsAvailableParam) {
        this.onlyShowColorsAvailable = true;
      }

      this.$watch('quickAddIndex', (index) => {
        Alpine.store('screen').isScrollableBody = index === null;
      });

      this.$watch('onlyShowColorsAvailable', (isShow) => {
        console.log('onlyShowColorsAvailable change: ');
        console.log(isShow);
        
        if (isShow) {
          window.sessionStorage.setItem('LIF-PARAMS-onlyShowColorsAvailable', '1');
        } else {
          window.sessionStorage.removeItem('LIF-PARAMS-onlyShowColorsAvailable');
        }
      });

      this.$watch('isSelectedVariantOOS', (isOOS) => {

        if (Alpine.store('cart').showUpdateItemPopup) {
          if (isOOS) {
            Alpine.store('pdp').oosEditATC = true;
          } else {
            Alpine.store('pdp').oosEditATC = false;
          }
        }
      });
      
      this.$watch('selectedVariant', (selectedVariant) => {
        
        if (this.updateSelectedVariantURLState && selectedVariant) {
          // const baseURL = window.location.origin + window.location.pathname;
          // const searchURL = `${baseURL}?variant=${selectedVariant.id}`;
          // window.history.replaceState(selectedVariant.id, document.title, searchURL);

          const url = new URL(window.location.href);

          // Add or update your parameter
          url.searchParams.set("variant", selectedVariant.id);

          // Push updated URL without reloading
          window.history.replaceState({}, "", url.toString());
        }

      });
      
      if (this.confirmBundleIsActive) {

        if (cardIndex == 0) { // Main product
          this.selectedBundleProductVariant = this.selectedVariant;
        } else if (this.product.id == this.addOnProductId) {
          this.selectedBundleAddOnVariant = this.selectedVariant;
        }

        this.$watch('selectedVariant', (newVariant) => {
          if (cardIndex == 0) { // Main product
            this.selectedBundleProductVariant = newVariant;
          } else if (this.product.id == this.addOnProductId){
            this.selectedBundleAddOnVariant = newVariant;
          }
        });

        this.$watch('addOnProductId', (addOnProductId) => {
          if (this.product.id == addOnProductId){
            this.selectedBundleAddOnVariant = this.selectedVariant;
          }
        });
      }
      
    },
    pushToBundle() {
      Alpine.store('bundleStore').bundles.push(this);
      console.log('Bundle registered', this.product?.id);
    },

    initialSyncBundleColors() {
      setTimeout(() => {

        const colorPos = this.optionIndex.color + 1;
        const selectedColor = this.selectedOptions[colorPos];
        
        if (selectedColor) {
          // Run bundle sync immediately
          this.syncBundleColor(selectedColor);
        }
      }, 500); // Let's load bundles
    },

    setSelectedVariantColorCode(colorCode) {
      this.selectedVariantColorCode = colorCode;

      const color = colorCode.replace('#', '');
      const r = parseInt(color.substr(0, 2), 16);
      const g = parseInt(color.substr(2, 2), 16);
      const b = parseInt(color.substr(4, 2), 16);

      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      this.variantInverseColor = brightness < 128 ? '#fff' : '#000';
    },

    onImageLoaded() {
      // setTimeout(() => {
        this.shouldProductImageShow = true;
      // }, 1000);
    },
    get restrictPDPRedirect() {
      const { offerCollections } = Alpine.store('offer1Free');
      const { baseURL } = Alpine.store('URL');
      
      const { hasSecondProduct, saleDetails } = Alpine.store('fwpOffer');
      const thisCollection = window.location.origin + window.location.pathname;
      if (!hasSecondProduct && saleDetails && saleDetails.targetCollection == thisCollection) {
        return true;
      }

      return restrictPDP || window.__LIF__.restrictPDPRedirect || (offerCollections && offerCollections.includes(baseURL));
    },
    gotoPDP(link) {
      // Check if offer 1 free and PDP not allowed
      if (this.restrictPDPRedirect) {
        this.quickAddIndex = this.cardIndex; 

        if (this.showCompleteLookModal) {
          this.showCompleteLookModal = false;
          this.openSideCartOnClose = true;
        }
      } else {
        window.location.href = link;
      }
    },
    closeMobileQuickAdd() {
      this.quickAddIndex = null;
      if (this.openSideCartOnClose) {
        this.openSideCartOnClose = false;
        Alpine.store('cart').isSideCartOpen = true;
      }
    },
    get PLPImageWidth() {
      return Alpine.store('screen').isMobile ? 800 : 800;
    },

    get PLPImageWidthPDP() {
      return Alpine.store('screen').isMobile ? 800 : 800;
    },

  
    get shouldShowEdd() { // Check if Estimated Delivery Date should show

      if (!Alpine.store('edd') || !this.product) {
        return false;
      }
      
      const { hideEddProductTags, hideEddVendors } = Alpine.store('edd').eddSettings;
      
      const hasHideEddTag = hideEddProductTags.some((t) => this.product.tags.includes(t));
      const hasHideEddVendor = hideEddVendors.includes(this.product.vendor);

      return !hasHideEddTag && !hasHideEddVendor;
    },

    get selectedVariant() {

      if (!this.product) {
        return null;
      }

      let variant = null;

      if (!this.product) {
        return null;
      }
      
      if (this.isSingleVariantProduct) {
        variant = this.product.variants[0];
      } else {

        variant = this.product.variants.find((v) => {
            let matched = true;
            for (let optionPosition in this.selectedOptions) {
              if (this.selectedOptions.hasOwnProperty(optionPosition)) {
                if (v['option'+optionPosition] != this.selectedOptions[optionPosition]) {
                  matched = false;
                }
              }
            }

            return matched;
        });
      }

      return variant;
    },
    get isSelectedColorOOS() {

      if (!this.optionIndex) {
        return false;
      }

      const colorOptionPosition = this.optionIndex.color + 1;

      const optionValue = this.selectedOptions[colorOptionPosition];

      // Check if selected color variant is oos
      const colorOptionKey = 'option'+colorOptionPosition;
      const firstAvailableSize = this.product.variants.find(v => v[colorOptionKey] == optionValue && (v.remaining_quantity > 0 || v.inventory_policy == 'continue'))
      return !firstAvailableSize;
    },
    get isSelectedVariantOOS() {
      if (!this.selectedVariant) {
        return true;
      }

      // Check in cart item qty too
      const cartVariantItem = Alpine.store('cart').cartItems.find(i => i.variant_id == this.selectedVariant.id);
      const cartVariantQty = cartVariantItem ? parseInt(cartVariantItem.quantity) : 0;

      return (this.selectedVariant.remaining_quantity - cartVariantQty) <= 0 && this.selectedVariant.inventory_policy != 'continue';
    },
    get isSelectedVarianQtyZero() {
      if (!this.selectedVariant) {
        return false;
      }

      return this.selectedVariant.remaining_quantity <= 0;
    },
    // get soldOutColorsForSelectedSize() {

    //   const selectedSize = this.selectedOptions[this.optionIndex.size + 1];
    //   const sizeOptionKey = 'option'+(this.optionIndex.size + 1);
    //   const colorOptionKey = 'option'+(this.optionIndex.color + 1);

    //   return this.product.variants
    //     .filter(v => v[sizeOptionKey] == selectedSize && v.metafields.sold_out)
    //     .map(v => v[colorOptionKey]);
    // },
    get selectedColorCode() {

      if (this.optionIndex && (this.optionIndex.color || this.optionIndex.color === 0)) {

        const selectedColor = this.selectedOptions[this.optionIndex.color + 1];

        if (window.__LIF__.color_variants_matadata) {
          const colorMetaObject = window.__LIF__.color_variants_matadata.find(v => v.color_variant_name == selectedColor);

          if (colorMetaObject) {
            return colorMetaObject.variant_color_code;
          }
        }
      }

      return '#000000';
    },
    get selectedFit() {
      if (this.optionIndex && (this.optionIndex.color || this.optionIndex.color === 0)) {
        const selectedColor = this.selectedOptions[this.optionIndex.color + 1];
        const map = window.__LIF__ && window.__LIF__.pdp_color_fit;
        if (map && map[selectedColor] == 'oversized') return 'oversized';
      }
      return 'extra_oversized';
    },
    get isExtraOversized() { return this.selectedFit === 'extra_oversized'; },
    async addToCart(saleData = {}) {

      if (!this.selectedVariant) {
        console.log('Selected variant not existing.');
        return;
      }

      if (Alpine.store('sale').refreshOnATC) {
        // Refresh cart items to get latest cart details to avoid multi tab issue
        Alpine.store('cart').isSideCartOpen = true;
        Alpine.store('cart').isCartInProgress = true;
        await Alpine.store('cart').loadItems();
      }

      const { 
        cartItems,
        shouldApplyMembershipDiscount, 
        hasFreeProduct,
        hasFixedPriceOffer,
        hasBundleItem,
        hasAbsoluteFreeProduct,
        removeMultipleItems,
      } = Alpine.store('cart');

      // Check for item sale property
      let properties = {};
      let bundleItem = null;

      
      // properties.__member_discount_percentage = saleData.memberDiscount.percentage;
      // properties.__member_discount_price = saleData.memberDiscount.price;
      
      if (Alpine.store('edd')) {
        const { eddDateText, daysInTransit } = Alpine.store('edd');
        if (eddDateText && daysInTransit) {
          properties.__estimated_delivery_date = eddDateText;
        }
      }
      
      /*
      if (Alpine.store('buyMoreSaveMoreOffer').isActive) {
        properties.__buy_more_bundle_item = { 
          buyMoreDiscounts: Alpine.store('buyMoreSaveMoreOffer').buyMoreDiscounts,
          saleName: 'Buy More Save More'
        };
      }

      const {
        settings: bundleSettings, // settings of active bundle sale in case of multiple bundle sale active
        isCompleted: isBundleCompleted,
        includedBundleComponents,
        manualActiveIndex,
        thisSaleDetails: bundleSaleDetails, // sale details of active bundle sale in case of multiple bundle sale active
      } = Alpine.store('customBundle');
      const { saleName, saleKey, componentIndex } = saleData.customBundle;

      if ((saleData.applicableSale == LifSale.OFFER_1_FREE || this.fwpProduct) && !hasFreeProduct) {
        const oneFreeProperties = {
          _is_free_shirt: true,
          _applied_offer_type: this.fwpProduct ? 'fwp' : 'Offer 1 Free',
          _free_theshold: window.__LIF__.free_product_threshold,
        }

        if (this.fwpProduct) {
          oneFreeProperties._fwp_first_product = true;
        }

        properties = { ...properties, ...oneFreeProperties };
      } else if (saleData.applicableSale == LifSale.OFFER_FIXED_PRICE && !hasFixedPriceOffer) {
          const fixedPriceProperties = {
            __fixed_price_offer: true,
            _applied_offer_type: '$5 Sweatshirt',
            _free_theshold: window.__LIF__.offer_fixed_price_settings.price_threshold,
          }
  
          properties = { ...properties, ...fixedPriceProperties };
      } else if (!hasAbsoluteFreeProduct && bundleSettings && saleKey && bundleSettings[saleKey].isActive) { 

        const bundleItemIndex = componentIndex ? componentIndex : 0;

        if(!isBundleCompleted[saleKey]) {
            const customBundleSaleProperties = {
              __winter_bundle_sale: { componentIndex : bundleItemIndex, productType: "", saleName, saleKey },
              _offer_limit_one_key: `custom-bundle-${saleKey}-${bundleItemIndex}` // This void to add same bundle index multiple times by checkout ext.
            }
            
            const { thisSettings, bundleKeyProducts } = Alpine.store('customBundle');

            // Check if bundle item is added
            if (!bundleKeyProducts[saleKey]) {
              bundleItem = {
                id: thisSettings.bundleProduct.variants[0].id,
                quantity: 1,
                properties: { 
                  __is_winter_product: true,
                  saleKey, // Add sale key to identify spcific sale in case multiple bundle sale is active
                },
              }
            }

            // Check if free product in cart
            if (hasAbsoluteFreeProduct) {
              const absoluteFreeProduct = cartItems.find((item) => item.properties.attributes && item.properties.attributes._is_absolute_free_product);

              // Delete Free Product
              if (absoluteFreeProduct) {
                await removeMultipleItems([absoluteFreeProduct.key]);
              }
            }

            properties = { ...properties, ...customBundleSaleProperties };
          

          // Allow to auto select filter after adding bundle item
          if (manualActiveIndex !== null) {
            Alpine.store('customBundle').manualActiveIndex = null;
          }
        } else if (saleData.applicableSale == LifSale.CUSTOM_BUNDLE) {
          const customBundleSaleProperties = {
            __winter_bundle_sale_fixed_price: { 
              type: 'FIXED', 
              price: parseFloat(saleData.customBundle.salePriceValue) * 100,
              saleName
            }
          }

          properties = { ...properties, ...customBundleSaleProperties };
        }
      } else if (saleData.applicableSale == LifSale.DYNAMIC_SALE) {
        const { saleTag, saleName, matchedProductTag, salePriceValue } = saleData.dynamicSale;
        const dynamicSaleProperty = {
          __dynamic_sale_tag: saleTag,
          __dynamic_sale_name: saleName,
          __tags: [matchedProductTag],
        }

        console.log(`salePriceValue: ${salePriceValue}`);
        console.log(`memberDiscountedPrice: ${saleData.memberDiscount.price}`);

        if (!shouldApplyMembershipDiscount || !saleData.memberDiscount.price || parseFloat(salePriceValue) < parseFloat(saleData.memberDiscount.price)) {
          // delete properties.__member_discount_percentage;
          properties = { ...properties, ...dynamicSaleProperty };
        } else {
          console.log('Member discount should apply.');
        }
      } else if (saleData.applicableSale == LifSale.FWP_SALE) {
        const { hasFreeProduct, hasSecondProduct, saleDetails } = Alpine.store('fwpOffer');
        const thisCollection = window.location.origin + window.location.pathname;
        if (hasFreeProduct && !hasSecondProduct && saleDetails.targetCollection == thisCollection) {
          properties._fwp_second_product = true;
        }
      
      } else if (saleData.applicableSale == LifSale.INCREMENTAL_SALE) {

        const { saleName, salePriceValue, offerCode } = saleData.incrementalSale;
        const variantPrice = this.product.variants[0].price / 100;
        if (variantPrice > this.incrementalSale.salePriceValue) {

          const lineItemIndex = offerCode == 'v2' ? Alpine.store('incrementalSaleV2').activeIndex : Alpine.store('incrementalSale').bundleItems.length;

          // Avoid duplicate offer to add
          if (Alpine.store('cart').isCartInProgress) {
            console.log('Sorry, Cart is still adding offer to cart. So please wait to finish!');
            return;
          }

          // Avoid duplicate offer to add
          if (Alpine.store('incrementalSale').bundleItemsByIndex[lineItemIndex]) {
            console.log('This offer item is already in your cart!');
            return;
          }

          properties.__incremental_sale = {
            type: Alpine.store('incrementalSale').isCompleted || offerCode == 'v2' ? 'FIXED' : 'SALE',
            price: salePriceValue * 100,
            offerCode: offerCode,
            lineItemIndex,
            saleName
          }

          Alpine.store('cart').isCartInProgress = true;
        }
      }
      
      // blackFridaySale should be combined with dynamic sale
      if (Alpine.store('blackFridaySale').isActive) {
        if (saleData.applicableSale == LifSale.BLACK_FRIDAY) {

          // Avoid duplicate offer to add
          if (Alpine.store('cart').isCartInProgress) {
            console.log('Sorry, Cart is still adding offer to cart. So please wait to finish!');
            return;
          }

          // Avoid duplicate offer to add
          if (Alpine.store('blackFridaySale').offerItemsByIndex[saleData.blackFriday.offerIndex]) {
            console.log('This offer item is already in your cart!');
            return;
          }

          properties.__black_friday_sale = { isOfferProduct: true, index: saleData.blackFriday.offerIndex };

          // Using '__winter_bundle_sale_fixed_price' to make this work as fixed price in Checkout Extensiblity App without modifying code
          properties.__winter_bundle_sale_fixed_price = { 
              type: 'FIXED', 
              price: parseFloat(saleData.blackFriday.salePriceValue) * 100,
              saleName: saleData.blackFriday.saleName
          }

          Alpine.store('cart').isCartInProgress = true;
        } else {
          if (Alpine.store('blackFridaySale').isAllowedBundleProduct(this.product)) {
            properties.__black_friday_sale = { isBundleProduct: true }
          }
        }
      }

      if (this.selectedVariant.price == 0) {
        properties._is_absolute_free_product = true;
        properties._free_theshold = window.__LIF__.free_product_threshold;
      }

      if (this.isProductDODLimt1) {
        properties = { ...properties, __has_dod_limit_1 : true };
        const { removeItem, dodLimit1Product } = Alpine.store('cart');

        // Check if dod limit 1 product already exist
        if (dodLimit1Product) {
          await removeItem(dodLimit1Product.key, false);
        }
      }

      if (this.product.is_oversold_product) {
        properties.__is_oversold_product = true;
      }

      // Check if collection offer is active and redirect is enabled
      const { saleDetails, offerCurrentSettings: offerSettings } = Alpine.store('offer1Free');

      if (offerSettings) {
        properties._is_funnel_product = true;

        if(offerSettings.enable_url_redirect) {
          atcRedirect = offerSettings.url_redirect+'?offersettings='+saleDetails.offerSettingKey;
        }
      }
      */

      const { isBuy1Get1Collection, shouldAllowToAddFreeProduct } = Alpine.store('buyOneGetOneOffer');

      if (saleData.__buy1_get1_offer || (isBuy1Get1Collection && shouldAllowToAddFreeProduct)) {
        properties.__buy1_get1_offer = 1;
        properties.__winter_bundle_sale_fixed_price = {
          type: "FIXED",
          price: 0,
          saleName:"Buy One Get One"
        }
      }

      // Check if collection offer is active and redirect is enabled
      const { isActive, cartFunnelProduct } = Alpine.store('freeProductTemplate');

      if (isActive && hasAbsoluteFreeProduct && !properties._is_absolute_free_product && !cartFunnelProduct) {
        properties._is_funnel_product = true;
      }

      // Check if product is adding from lookbook
      if (window.__LIF__.isLookbookCollection) {
        properties._lookbook_collection = Alpine.store('URL').baseURL;
      }

      const item = {
        id: this.selectedVariant.id,
        quantity: this.itemQty,
        properties
      }



      if (this.product.selling_plan_id) {
        item.selling_plan = this.product.selling_plan_id;
      }

      // Close shop simillar and Complete a look modal.
      if (this.showModal) {
        this.showModal = false;
      }

      if (atcRedirect) {

        if (atcRedirect[0] == '#') {
          
          Alpine.store('freeProductTemplate').atcInitiated = true;

          setTimeout(() => {
            const element = document.querySelector(atcRedirect);
            console.log(element);

            if (element) {
              const headerOffset = 80;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.scrollY - headerOffset;

              window.scrollTo({ top: offsetPosition, behavior: "smooth" });
            } else {
              console.log('No element to scroll.');
            }
          }, 500); // Let's Load visibility
        }

        Alpine.store('cart').addItems(bundleItem ? [item, bundleItem] : [item], () => {
          Alpine.store('cart').isCartInProgress = false;
          if (atcRedirect[0] != '#') {
            window.location.href = atcRedirect
          }
        }, false);
      } else {
        this.quickAddIndex = null;
        Alpine.store('collectionLookbook').quickAddProductHandle = null;

        Alpine.store('cart').addItems(bundleItem ? [item, bundleItem] : [item], () => {
          Alpine.store('cart').isCartInProgress = false;
        });
      }
    },

    isOOS(thisOptionPosition, thisOptionValue) {
      // console.log(`${thisOptionPosition} -> ${thisOptionValue}`);
      // return selectedColor;
      // if (availbleSwatches.length === 0) {
      //   return true;
      // }
      // return !availbleSwatches.split(',').includes(selectedColor);

      const thisVariant = this.product.variants.find((v) => {
        let matched = true;
        for (let optionPosition in this.selectedOptions) {
          if (optionPosition == thisOptionPosition) {
            if (v['option'+thisOptionPosition] != thisOptionValue) {
              matched = false;
            }
          } else {
            if (this.selectedOptions.hasOwnProperty(optionPosition)) {
              if (v['option'+optionPosition] != this.selectedOptions[optionPosition]) {
                matched = false;
              }
            }
          }
        }

        return matched;
      });

      if (!thisVariant) {
        return true;
      }

      // Check in cart item qty too
      const cartVariantItem = Alpine.store('cart').cartItems.find(i => i.variant_id == thisVariant.id);
      const cartVariantQty = cartVariantItem ? parseInt(cartVariantItem.quantity) : 0;

      return (thisVariant.remaining_quantity - cartVariantQty) <= 0 && thisVariant.inventory_policy != 'continue';
    },
    isOOSAndNoPreOrder(thisOptionPosition, thisOptionValue) {
        const thisVariant = this.product.variants.find((v) => {
        let matched = true;
        for (let optionPosition in this.selectedOptions) {
          if (optionPosition == thisOptionPosition) {
            if (v['option'+thisOptionPosition] != thisOptionValue) {
              matched = false;
            }
          } else {
            if (this.selectedOptions.hasOwnProperty(optionPosition)) {
              if (v['option'+optionPosition] != this.selectedOptions[optionPosition]) {
                matched = false;
              }
            }
          }
        }

        return matched;
      });

      if (!thisVariant) {
        return true;
      }

      const hasPreOrderVariant = thisVariant.pre_order_variant && thisVariant.pre_order_variant.is_available;
      return thisVariant.remaining_quantity <= 0 && thisVariant.inventory_policy != 'continue' && !hasPreOrderVariant;
    },
    selectOptionAndATC(optionPosition, optionValue, saleData) {
      this.selectedOptions[optionPosition] = optionValue;
      this.showOptionSelection = false;
      this.addToCart(saleData);
    },

    selectOption(optionPosition, optionValue, isMain = false) {

      // FIRST: detect source
      if (isMain) {
        console.log('Variant clicked from MAIN product');
      }

      this.selectedOptions[optionPosition] = optionValue;

      // this.selectedSize = optionValue;
      
      const colorOptionPosition = this.optionIndex.color + 1;

      // Check if selected color variant is oos
      if (colorOptionPosition == optionPosition && this.isSelectedVariantOOS && !this.onlyShowColorsAvailable) {
        
        const colorOptionKey = 'option'+colorOptionPosition;
        const firstAvailableSize = this.product.variants.find(v => v[colorOptionKey] == optionValue && (v.remaining_quantity > 0 || v.inventory_policy == 'continue'))

        if (firstAvailableSize) {
          const sizeOptionPosition = this.optionIndex.size + 1;
          const sizeOptionKey = 'option'+sizeOptionPosition;
          this.selectedOptions[sizeOptionPosition] = firstAvailableSize[sizeOptionKey];
        }
      }
      // MAIN ➜ BUNDLE COLOR SYNC
      if (isMain && optionPosition == colorOptionPosition) {
        this.syncBundleColor(optionValue, isMain);
      }
    },
    
    // memberDiscountPercentage() {
    //   const memberPriceTagPrefix = 'MEMBER-';
    //   const productTags = this.product.tags.split(',').map((t) => t.trim());

    //   const memberTag = productTags.find((item) => item.indexOf(memberPriceTagPrefix) > -1);
    //   const memberDiscountPerc = typeof memberTag !== 'undefined' ? memberTag.replace(memberPriceTagPrefix, '') : 0;

    //   return parseFloat(memberDiscountPerc);
    // },

    get colorsAvailable() {

      if (!this.onlyShowColorsAvailable) {
        return [];
      }

      if (!this.optionIndex.size && this.optionIndex.size !== 0) {
        return [];
      }
      const selectedSize = this.selectedOptions[this.optionIndex.size + 1];

      const sizeOption = 'option'+ (this.optionIndex.size + 1);
      const colorOption = 'option'+ (this.optionIndex.color + 1);
      const availableColorVariants = this.product.variants.filter(v => v[sizeOption] == selectedSize && (v.remaining_quantity > 0 || v.inventory_policy == 'continue'));

      return availableColorVariants.length > 0 ? availableColorVariants.map(v => v[colorOption]) : [];
    },

    normalizeColor(value) {
      if (!value) return '';

      return value
        .toString()
        .split(/[-:|]/)   // split on -, :, |
        .pop()            // take last segment
        .trim()
        .toLowerCase();
    },

    syncBundleColor(mainOriginalColor, isMain) {
      const store = Alpine.store('bundleStore');

      // if (store.bundleInteractionLocked) {
      //   console.log('Sync skipped (bundle interaction detected)');
      //   return;
      // }

      const mainColor = this.normalizeColor(mainOriginalColor);
      console.log('MAIN normalized color:', mainColor);

      store.bundles.forEach((bundle, index) => {
        // console.group(`Bundle #${index + 1}`);

        const colorPos = bundle.optionIndex.color + 1;
        const colorKey = 'option' + colorPos;

        const matchFullColorName = bundle.product.variants.find(v => {
          const bundleColor = v[colorKey];

          // Exclude sold out colors
          if (bundle.product.sold_out_color_names.includes(bundleColor)) {
            return false;
          }

          // Check full color name if match first
          return bundleColor == mainOriginalColor;
        });

        const match = bundle.product.variants.find(v => {
          // Exclude sold out colors
          if (bundle.product.sold_out_color_names.includes(v[colorKey])) {
            return false;
          }

          const bundleColor = this.normalizeColor(v[colorKey]);

          // if (mainColor == 'lemonade' && bundleColor == 'lemonade') {
          //   console.log(
          //     'Checking bundle variant:',
          //     v.id,
          //     '| raw:',
          //     v[colorKey],
          //     '| normalized:',
          //     bundleColor,
          //     '| raw main Color:',
          //     mainOriginalColor,
          //     '| normalized mainColor:',
          //     mainColor
          //   );
          // }

          // If not, check normalizeColor
          return bundleColor === mainColor;
        });

        if (!matchFullColorName && !match) {
          // console.warn('No matching color found in bundle');
          // console.groupEnd();
          return;
        }

        // Apply the exact bundle value (with its own prefix if any)
        bundle.selectedOptions[colorPos] = matchFullColorName ? matchFullColorName[colorKey] : match[colorKey];

        bundle.updateSelectedVariant?.();
        this.selectedVariant = matchFullColorName ? matchFullColorName : match;

          // console.log(
          //   'alpine_js_media source:',
          //   (this.selectedVariant ? this.selectedVariant.image : this.mainImage) + '&width=400'
          // );
        bundle.updateMedia?.();

        // console.log('Bundle synced →', match[colorKey]);
        // console.groupEnd();
      });

      // Finally move scroll to top to avoid sticky inconsistancy
      if (!Alpine.store('screen').isMobile && isMain === true) {
        console.log('Moving to top:...');

        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
  }));

  Alpine.data('cartItemEdit', (productHandle, productImageURL, cardIndex) => ({
    customerLoggedIn: document.getElementById('customerLoggedIn') && document.getElementById('customerLoggedIn').value === 'true', 
    showUpdateItemPopup: false, 
    showDeleteItemPopup: false,
    showWishlistItemPopup: false,
    isRemoveFromWishlist: false,
    editItemKey: null,
    editItemQty: 1,
    removeItemKey: null,
    updateIsInProgress: false,

    editItem(productHandle, editItemKey, editItemQty) {
      // debugger;
      if (Alpine.store('cart').isCartQtyInProgress) {
        console.log('Cart update is already in Progress.');
        return false;
      }

      Alpine.store('cart').showUpdateItemPopup = true;
      Alpine.store('cart').isSideCartOpen = false;

      // console.log('productHandle: ');
      // console.log(productHandle);

      this.editItemKey = editItemKey;
      this.editItemQty = editItemQty;

      Alpine.store('cart').editItemDetails = {
        key: editItemKey,
        qty: editItemQty
      };
      const selectedVariantId = editItemKey.split(':')[0];

      document.getElementById('edit_product_info').innerHTML = '';
      // document.querySelectorAll('.edit_product_info').forEach(element => {
      //   element.innerHTML = '';
      // });
      console.log(`/products/${productHandle}?view=cart-edit&variant=` + selectedVariantId);
      fetch(`/products/${productHandle}?view=cart-edit&variant=` + selectedVariantId)
      .then((response) => response.text())
      .then((html) => {
        // console.log(html);
        console.log(document.getElementById('edit_product_info'));
        document.getElementById('edit_product_info').innerHTML = html;
        // document.querySelectorAll('.edit_product_info').forEach(element => {
        //   element.innerHTML = html;
        // });
      })
      .catch((e) => {
        console.error(e);
        // console.log('Error fetching product info and populating it.');
      });
    },

    updateItem(e) {
      e.preventDefault();

      this.updateIsInProgress = true;

      const { key: editItemKey, qty: editItemQty } = Alpine.store('cart').editItemDetails;

      const variatSelector = document.querySelector('variant-selects');

      if (variatSelector.currentVariant) {
        // console.log('Log current variant id: ');
        // console.log(variatSelector.currentVariant.id)
        // debugger;
        const selectedItem = Alpine.store('cart').cartItems.find((i) => i.key == editItemKey);
        console.log('editItemKey: ', editItemKey);
        const item = {
          id: variatSelector.currentVariant.id,
          quantity: editItemQty,
          properties: selectedItem.properties.attributes,
        }

        // Remove existing item
        Alpine.store('cart').removeAndAddItem(editItemKey, item, () => {;
          Alpine.store('cart').showUpdateItemPopup = false;
          Alpine.store('cart').isSideCartOpen = true;
          this.updateIsInProgress = false;
        })
      } else {
        this.updateIsInProgress = false;
      }
    },


  }));

  Alpine.data('PDPGallaryKingdom', () => ({
    allProductMedia: [],
    productMedia: [],
    selectedColor: '',
    mySwiper: null,
    activeIndexes: [],
    currentIndex: 0,

    init() {
      if (this.product) {
        const allProductMedia = JSON.parse(document.querySelector('#product_'+this.product.handle+'_media[type="application/json"]').textContent);

        /*
          Split the image alt text into array using delimiter "|"
          array[0] => is for variant id which is used to get the images of the selected color.
          array[1] => is used to show the label on the image as glo images.
        */
        /*allProductMedia.forEach(m => {
          const [altText, imgLabel] = m.alt.split('|').map(m => m.trim());
          m.alt = altText;
          m.img_label = imgLabel;

          this.allProductMedia.push(m);
        });*/
        allProductMedia.forEach(m => {
          const parts = m.alt
            ? m.alt.split('|').map(p => p.trim())
            : [];

          m.alt = parts[0] || '';        // 1st part
          m.img_label = parts[1] || '';  // 2nd part
          m.img_label2 = parts[2] || '';   // 3rd part

          this.allProductMedia.push(m);
        });
        
        if (this.product) {
          const colorOptionIndex = this.optionIndex.color;

          const variantColors = [];
          for(let variant of this.product.variants) {
            const variantColor = variant['option'+(colorOptionIndex+1)];

            if (!variantColors.includes(variantColor) && !this.product.sold_out_color_names.includes(variantColor)) {
              variantColors.push(variantColor);
            }
          }
        
          // Videos should be first in list
          const sortedMedialList = [];
          for(let variantColor of variantColors) {
            // const variantVideos = this.allProductMedia.filter(m => m.alt == variantColor && m.media_type == 'video');
            const variantPhotos = this.allProductMedia.filter(m => m.alt == variantColor && m.media_type == 'image');

            // sortedMedialList.push(...variantVideos);
            sortedMedialList.push(...variantPhotos);
          }

          this.allProductMedia = sortedMedialList;

          this.selectedColor = this.selectedOptions[colorOptionIndex + 1];
        }

      }

      this.loadMedia();
      this.currentIndex = 0;
      
      this.$watch('selectedColor', (newColor) => {
        this.onColorChange(newColor);
      });

      this.initializeSlider()
    },

    onColorChange(newColor) {
      if (Alpine.store('screen').isMobile) {
        this.activeIndexes = [];
        this.currentIndex = null;

        // for(let [index, media] of this.allProductMedia) {
        for(let index = 0; index < this.allProductMedia.length; index++) {
          this.activeIndexes.push(index);

          if (this.currentIndex === null && this.allProductMedia[index].alt == newColor) {
            this.currentIndex = index;   
          }
        }

        // this.currentIndex = 0;

        // Moved to first index
        this.mySwiper.allowSlideNext = true;
        this.mySwiper.allowSlidePrev = true;

        // this.mySwiper.slideTo(this.activeIndexes[0], 0, false);
        this.mySwiper.slideTo(this.currentIndex, 0, false);

        this.sliderIndexIsSet = true;
      } else {

        // Desktop
        this.activeIndexes = [];
        
        for(let index = 0; index < this.allProductMedia.length; index++) {
          if (this.allProductMedia[index].alt == newColor) {
            this.activeIndexes.push(index);
          }
        }
      }
    },
    moveNext() {
      const nextIndex = this.currentIndex + 1;
      if (this.activeIndexes[nextIndex]) {
        this.currentIndex = nextIndex;
        this.mySwiper.slideTo(this.activeIndexes[nextIndex]);
      }
    },
    movePrevious() {
      const previousIndex = this.currentIndex - 1;
      if (this.activeIndexes[previousIndex] || this.activeIndexes[previousIndex] === 0) {
        this.currentIndex = previousIndex;
        this.mySwiper.slideTo(this.activeIndexes[previousIndex]);
      }
    },

    loadMedia() {
      const filteredMedia = this.allProductMedia;

      // const videos = filteredMedia.filter(m => m.media_type == 'video');
      // const images = filteredMedia.filter(m => m.media_type == 'image');
      
      this.productMedia = this.allProductMedia; // [...videos, ...images];

      // console.log('this.productMedia loaded...');
    },

    initializeSlider() {
      
      setTimeout(() => {
        // if (this.mySwiper) {
        //   this.mySwiper.destroy(true, true); // Destroy with deleteInstance and cleanStyles
        // }

        this.mySwiper = new Swiper('.swiper-container-kingdom-media-gallary', {
          loop: false,
          slidesPerView: 1.5,
          spaceBetween: 0,
          speed: 800,
          autoplay: false,
          currentIndex: 0,
          // autoplay: {
          //   delay: 4000,
          //   disableOnInteraction: false
          // },
          navigation: {
            // nextEl: '.swiper-button-next-kingdom-media-gallary',
            // prevEl: '.swiper-button-prev-kingdom-media-gallary'
          },
          virtual: {
            addSlidesBefore: 1,
            addSlidesAfter: 1
          },
        });

        this.mySwiper.on('slideChange', () => {
          
          console.log('Slide changed to index:', this.mySwiper.activeIndex);

          this.currentIndex = this.activeIndexes.findIndex(i => i == this.mySwiper.activeIndex);
          const nextIndex = this.currentIndex + 1;
          const previousIndex = this.currentIndex - 1;

          // Check if next move to allowed
          if (!this.activeIndexes[nextIndex]) {
            this.mySwiper.allowSlideNext = false;
          } else {
            this.mySwiper.allowSlideNext = true;
          }

          // Check if prev move to allowed
          if (!this.activeIndexes[previousIndex] && this.activeIndexes[previousIndex] !== 0) {
            this.mySwiper.allowSlidePrev = false;
          } else {
            this.mySwiper.allowSlidePrev = true;
          }
          
        });

        // Initialize first color images
        this.onColorChange(this.selectedColor);
      }, 500);
    },

    get selectedColorCode() {

      if (window.__LIF__.color_variants_matadata) {
        const colorMetaObject = window.__LIF__.color_variants_matadata.find(v => v.color_variant_name == this.selectedColor);

        if (colorMetaObject) {
          return colorMetaObject.variant_color_code;
        }
      }

      return '#000000';
    },

    get selectedtextColorCode() {

      if (window.__LIF__.color_variants_matadata) {
        const colorMetaObject = window.__LIF__.color_variants_matadata.find(v => v.color_variant_name == this.selectedColor);

        if (colorMetaObject) {
          return colorMetaObject.atc_text_color;
        }
      }

      return '#ffffff';
    },

    get selectedFit() {
      const map = window.__LIF__ && window.__LIF__.pdp_color_fit;
      if (map && map[this.selectedColor] == 'oversized') return 'oversized';
      return 'extra_oversized';
    },

    get isExtraOversized() { return this.selectedFit === 'extra_oversized'; },

    get firstColorMediaIndex() {
      if (!this.productMedia || !this.productMedia.length) return -1;
      return this.productMedia.findIndex(m => m.alt == this.selectedColor && m.media_type == 'image');
    }

    // get productMedia() {
    //   if (!this.optionIndex) {
    //     return this.allProductMedia;
    //   }
    //   const colorIndex = this.optionIndex.color;
    //   const selectedColorName = this.selectedOptions[colorIndex];

    //   const filteredMedia = selectedColorName ? this.allProductMedia.filter(m => m.alt == selectedColorName) : this.allProductMedia;

    //   const videos = filteredMedia.filter(m => m.media_type == 'video');
    //   const images = filteredMedia.filter(m => m.media_type == 'image');
      
    //   return [...videos, ...images];

    // }
  }));

  Alpine.data('PDPGallaryKingdomSelectedColors', () => ({
    allProductMedia: [],
    productMedia: [],
    selectedColor: '',
    mySwiper: null,
    activeIndexes: [],
    currentIndex: 0,
    editionColor: null,
    currentSwipperIndex: 0,

    init() {
      if (this.product) {
        this.allProductMedia = JSON.parse(document.querySelector('#product_'+this.product.handle+'_media[type="application/json"]').textContent);

        if (this.product) {
          const colorOptionIndex = this.optionIndex.color;

          const variantColors = [];
          for(let variant of this.product.variants) {
            const variantColor = variant['option'+(colorOptionIndex+1)];

            if (!variantColors.includes(variantColor)) {
              variantColors.push(variantColor);
            }
          }
        
          // Videos should be first in list
          const sortedMedialList = [];
          for(let variantColor of variantColors) {
            const variantVideos = this.allProductMedia.filter(m => m.alt == variantColor && m.media_type == 'video');
            const variantPhotos = this.allProductMedia.filter(m => m.alt == variantColor && m.media_type == 'image');

            sortedMedialList.push(...variantVideos);
            sortedMedialList.push(...variantPhotos);
          }

          this.allProductMedia = sortedMedialList;

          this.selectedColor = this.selectedOptions[colorOptionIndex + 1];          
        }

        this.$watch('quickAddProductEditionColor', () => {

          if (Alpine.store('collectionLookbook').quickAddProductHandle == this.product.handle) {
            const colorOptionIndex = this.optionIndex.color;

            // Assign selected color
            this.editionColor = Alpine.store('collectionLookbook').quickAddProductEditionColor;
            this.selectOption(colorOptionIndex + 1, this.editionColor);
            this.selectedColor = this.editionColor;
          }
        });
      }

      this.loadMedia();
      this.currentIndex = 0;
      
      this.$watch('selectedColor', (newColor) => {
        this.onColorChange(newColor);
      });

      this.initializeSlider()
    },

    get quickAddProductEditionColor() {
      return Alpine.store('collectionLookbook').quickAddProductEditionColor;
    },

    get editionColorKey() {
      if (!this.editionColor) {
        return '';
      }
      return this.editionColor.toLowerCase().replaceAll(' ', '');
    },
    onColorChange(newColor) {

      this.activeIndexes = [];

      // for(let [index, media] of this.allProductMedia) {
      for(let index = 0; index < this.allProductMedia.length; index++) {
        if (this.allProductMedia[index].alt == newColor) {
          this.activeIndexes.push(index);
        }
      }

      this.currentIndex = 0;

      // Moved to first index
      this.mySwiper.allowSlideNext = true;
      this.mySwiper.allowSlidePrev = true;

      this.mySwiper.slideTo(this.activeIndexes[0], 0, false);
      this.currentSwipperIndex = this.activeIndexes[0];

      this.mySwiper.allowSlidePrev = false;
    },
    moveNext() {
      const nextIndex = this.currentIndex + 1;
      if (this.activeIndexes[nextIndex]) {
        this.currentIndex = nextIndex;
        this.mySwiper.slideTo(this.activeIndexes[nextIndex]);
      }
    },
    movePrevious() {
      const previousIndex = this.currentIndex - 1;
      if (this.activeIndexes[previousIndex] || this.activeIndexes[previousIndex] === 0) {
        this.currentIndex = previousIndex;
        this.mySwiper.slideTo(this.activeIndexes[previousIndex]);
      }
    },

    goToSlide(index) {
      this.mySwiper.slideTo(index);
    },

    loadMedia() {
      const filteredMedia = this.allProductMedia;

      // const videos = filteredMedia.filter(m => m.media_type == 'video');
      // const images = filteredMedia.filter(m => m.media_type == 'image');
      
      this.productMedia = this.allProductMedia; // [...videos, ...images];

      // console.log('this.productMedia loaded...');
    },

    initializeSlider() {
      
      setTimeout(() => {
        // if (this.mySwiper) {
        //   this.mySwiper.destroy(true, true); // Destroy with deleteInstance and cleanStyles
        // }

        const containerId = 'swiper_container_'+this.product.handle+'_'+this.editionColorKey;
        const loopbookSwiperContainer = document.getElementById(containerId)
        this.mySwiper = new Swiper(loopbookSwiperContainer ? loopbookSwiperContainer : '.swiper-container-kingdom-media-gallary', {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 800,
          autoplay: false,
          currentIndex: 0,
          // autoplay: {
          //   delay: 4000,
          //   disableOnInteraction: false
          // },
          navigation: {
            // nextEl: '.swiper-button-next-kingdom-media-gallary',
            // prevEl: '.swiper-button-prev-kingdom-media-gallary'
          },
          virtual: {
            addSlidesBefore: 1,
            addSlidesAfter: 1
          }
        });

        this.mySwiper.on('slideChange', () => {
          
          console.log('Slide changed to index:', this.mySwiper.activeIndex);
          this.currentSwipperIndex = this.mySwiper.activeIndex;

          this.currentIndex = this.activeIndexes.findIndex(i => i == this.mySwiper.activeIndex);
          const nextIndex = this.currentIndex + 1;
          const previousIndex = this.currentIndex - 1;

          // Check if next move to allowed
          if (!this.activeIndexes[nextIndex]) {
            this.mySwiper.allowSlideNext = false;
          } else {
            this.mySwiper.allowSlideNext = true;
          }

          // Check if prev move to allowed
          if (!this.activeIndexes[previousIndex] && this.activeIndexes[previousIndex] !== 0) {
            this.mySwiper.allowSlidePrev = false;
          } else {
            this.mySwiper.allowSlidePrev = true;
          }
          
        });

        // Initialize first color images
        this.onColorChange(this.selectedColor);
      }, 500);
    },

    get selectedColorCode() {

      if (window.__LIF__.color_variants_matadata) {
        const colorMetaObject = window.__LIF__.color_variants_matadata.find(v => v.color_variant_name == this.selectedColor);

        if (colorMetaObject) {
          return colorMetaObject.variant_color_code;
        }
      }

      return '#000000';
    },

    get selectedtextColorCode() {

      if (window.__LIF__.color_variants_matadata) {
        const colorMetaObject = window.__LIF__.color_variants_matadata.find(v => v.color_variant_name == this.selectedColor);

        if (colorMetaObject) {
          return colorMetaObject.atc_text_color;
        }
      }

      return '#ffffff';
    }
  }));

  Alpine.data('PDPVariantSelection', (selected) => ({
    selected: selected,

    handleVariantChange(event) {
      console.log('handleVariantChange...');
      if (event.target.checked) {
        this.selected = event.target.value;
      } else {
        this.selected = '';
      }
    }
  }));

  Alpine.data('productForm', (selectedId) => ({
    selectedVariantId: selectedId,
    selectedQuantity: 1,
    
    handleVariantChange(event) {
      console.log('productForm: handleVariantChange...');
      console.log(event.target.value);

      this.selectedVariantId = event.target.value;
    }
  }));

  Alpine.data('countdownTimer', (promoLength, slideSpeed) => ({ 
    startTime: null,
    remaintingTime: 0,
    saleName: '', 
    targetCollection: '' ,
    salesBanners: [],
    activeSlide: 0,
    isActiveSaleTimer: false,
    timerInterval: null,
    slideInterval: null,

    get offerActivationCompleted() {
      return Alpine.store('customBundle').activationCompleted || 
      Alpine.store('dynamicSale').activationCompleted || 
      Alpine.store('offer1Free').activationCompleted ||
      Alpine.store('incrementalSale').activationCompleted;
    },

    init() {
      this.initTimer();

      this.$watch('offerActivationCompleted', () => {
        this.initTimer();
      });
    },

    initTimer() {
      let { saleDetails } = Alpine.store('dynamicSale');

      if (!saleDetails) {
        saleDetails = Alpine.store('customBundle').thisSaleDetails;
      }

      if (!saleDetails) {
        saleDetails = Alpine.store('customBundle').recentSaleDetails;
      }

      if (!saleDetails) {
        saleDetails = Alpine.store('incrementalSale').saleDetails;
      }

      if (saleDetails && saleDetails.saleExpiry) {

        if (this.timerInterval) {
          clearInterval(this.timerInterval);
        }

        this.isActiveSaleTimer = true;
        this.saleName = saleDetails.saleName;
        this.startTime = saleDetails.saleExpiry.timerExpiryTime;
        this.targetCollection = saleDetails.targetCollection;
        
        if (this.startTime) {
          window.countDownSettings = {
            timerStartTime: this.startTime,
          };

          this.remaintingTime = this.calculateRemainingTime();

          this.timerInterval = setInterval(() => {
            const remaintingTime = this.calculateRemainingTime();

            if (remaintingTime) {
              this.remaintingTime = remaintingTime;
            } else {
              this.startTime = null;
              this.isActiveSaleTimer = false;
              clearInterval(this.timerInterval);
            }
          }, 1000);
        }
      } else {
        // To skip index for sale timer
        this.activeSlide = 1;
        this.isActiveSaleTimer = false;
        
        if (this.timerInterval) {
          clearInterval(this.timerInterval);
        }
      }

      // Set timer to slide show
      let numberOfSlides = parseInt(promoLength);
      if (this.isActiveSaleTimer) {
        numberOfSlides += 1;
      }

      if (this.slideInterval) {
        clearInterval(this.slideInterval);
      }

      this.slideInterval = setInterval(() => {
        this.activeSlide = (this.activeSlide + 1) % numberOfSlides;

        if (!this.isActiveSaleTimer && this.activeSlide === 0) {
          // To skip index for sale timer
          this.activeSlide = 1;
        }

      }, slideSpeed);
    },

    get saleNameDisplay() {
      return this.saleName ? this.saleName.replaceAll('_', ' ').toUpperCase() : '';
    },
    get bannerText() {

      if (!this.salesBanners) {
        return null;
      }

      // Find banner text
      const banner = this.salesBanners.find((b) => b.sales_tag_name === this.saleName);
      return banner ? banner.sales_banner_text.replace('{{sale_countdown}}', this.remaintingTime) : null;
    },
    calculateRemainingTime() {
      if (!this.startTime) {
        // this.$emit('onExpired');
        return false;
      }

      const remainingSeconds = this.startTime - new Date().getTime();

      if (remainingSeconds < 0) {
        // this.$emit('onExpired');
        return false;
      }

      return this.secondsToHms(remainingSeconds / 1000);
    },
    secondsToHms(sec) {
      const seconds = Number(sec);

      let day = '';

      const d = Math.floor(seconds / (3600 * 24));
      if (d >= 1) {
        day = `${d}d:`;
      }

      const h = this.addLeadingZero(Math.floor((seconds / 3600) % 24).toString());
      const m = this.addLeadingZero(Math.floor((seconds % 3600) / 60).toString());
      const s = this.addLeadingZero(Math.floor((seconds % 3600) % 60).toString());

      return `${day} ${h}h : ${m}m : ${s}s`;
    },
    addLeadingZero(num) {
      return num.padStart(2, '0');
    },

  }));

  // Reactive reference of store for easy access
  Alpine.data('cartDrawer', () => ({
    init() {
      this.$watch('isCartLoading', (isLoading) => {
        if (!isLoading) {
          Alpine.store('blackFridaySale').adjustBundleTag('blackfriday-bundle-item-side-cart');
        }
      });
    },
    get isCartLoading() {
      return Alpine.store('cart').isLoading;
    },
    get cartHasLoaded() {
      return Alpine.store('cart').cartHasLoaded
    },
    get hasFreeTemplateBundle() {
      return Alpine.store('freeProductTemplate').isActive && Alpine.store('freeProductTemplate').cartAbsoluteFreeProduct;
    },
    get recentlyAddedItem() {
      return Alpine.store('cart').recentlyAddedItem
    },
    get recentlyAddedItemHasLimitOne() {
      if (!this.recentlyAddedItem) {
        return null;
      }
      return this.recentlyAddedItem.properties.attributes.__has_dod_limit_1
    },
    get cartItemHasLimitOne() {
      return Alpine.store('cart').dodLimit1Product;
    },
    get recentlyAddedItemIsBundleItem() {
      if (!Alpine.store('cart').recentlyAddedItem) {
        return null;
      }

      const itemAttributes = Alpine.store('cart').recentlyAddedItem.properties.attributes;

      return !!(itemAttributes.__winter_bundle_sale
      || itemAttributes.__is_winter_product
      || itemAttributes._bb_upgrade_kit
      || itemAttributes._bb_upgrade_shirt
      || (itemAttributes._is_free_shirt && itemAttributes._applied_offer_type == 'fwp')
      || itemAttributes._fwp_second_product
      || itemAttributes.__glo_bundle)
      || Alpine.store('incrementalSale').isBundleItem(Alpine.store('cart').recentlyAddedItem)
      || (this.hasFreeTemplateBundle && (itemAttributes._is_absolute_free_product || itemAttributes._is_funnel_product));
    },
    get cartBundleProduct() {
      return Alpine.store('customBundle').bundleKeyProducts;
    },
    get fwpItems() {
      const fwpFreeShirt = Alpine.store('cart').cartItems.find((i) => i.properties.attributes._is_free_shirt && i.properties.attributes._applied_offer_type == 'fwp');
      const fwpSecondShirt = Alpine.store('cart').cartItems.find((i) => i.properties.attributes._fwp_second_product);

      if (fwpFreeShirt || fwpSecondShirt) {
        return [fwpFreeShirt, fwpSecondShirt];
      } else {
        return [];
      }
    },
    get gloBundleItemCollection() {
      const bundleItems =  Alpine.store('cart').cartItems.filter((i) => i.properties.attributes.__glo_bundle);

      // Group by bundle index
      const bundleItemGroups = {};
      for(let bundleItem of bundleItems) {
        const bundleIndex = bundleItem.properties.attributes.__glo_bundle.bundleIndex;

        if (!bundleItemGroups[bundleIndex]) {
          bundleItemGroups[bundleIndex] = [];
        }

        bundleItemGroups[bundleIndex].push(bundleItem);
      }

      return Object.values(bundleItemGroups).reverse();

    },
    get cartHasIncrementalItem() {
      return !!Alpine.store('cart').cartItems.find((i) => i.properties.attributes.__incremental_sale);
    },
    get cartBBKitItems() {
      const bbKit = Alpine.store('cart').cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_kit);
      const bbShirt = Alpine.store('cart').cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_shirt);

      if (bbKit || bbShirt) {
        return [bbKit, bbShirt];
      } else {
        return [];
      }
    },
    get cartBBKitItemsTitle() {
      const bbKit = Alpine.store('cart').cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_kit);
      const bbShirt = Alpine.store('cart').cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_shirt);

      if (!bbKit || !bbShirt) {
        return 'noksdfnlsdf'
      }

      let kitPrice = bbKit.final_line_price / 100;
      if (bbKit.properties.attributes['_bb_offer_type--free_kit']) {
        kitPrice = bbShirt.final_line_price / 100;
      }

      return `${bbKit.product_title} - $${kitPrice}`;
    },
    get cartBundleItems() {
      const { hasBundleItem, cartBundleItems } = Alpine.store('cart');
      if (cartBundleItems.length > 0 && hasBundleItem) {
        return cartBundleItems;
      }

      return [];
    },
    get hasBundleItem() {
      return Alpine.store('cart').hasBundleItem;
    },
    get allIncludedBundleComponents() {
      return Alpine.store('customBundle').allIncludedBundleComponents;
    },
    get allItemsByBundleIndex() {
      return Alpine.store('customBundle').allItemsByBundleIndex;
    },
    get nonBundleCartItems() {
      return Alpine.store('cart').cartItems.filter((i) => {
        const isBundleItem = (
          i.properties.attributes.__winter_bundle_sale 
          || i.properties.attributes.__is_winter_product
          || i.properties.attributes._bb_upgrade_kit
          || i.properties.attributes._bb_upgrade_shirt
          || (i.properties.attributes._is_free_shirt && i.properties.attributes._applied_offer_type == 'fwp')
          || i.properties.attributes._fwp_second_product
          || i.properties.attributes.__glo_bundle
          || Alpine.store('incrementalSale').isBundleItem(i))
          || (this.hasFreeTemplateBundle && (i.properties.attributes._is_absolute_free_product || i.properties.attributes._is_funnel_product));
        const isRecentItem = this.recentlyAddedItem && i.key == this.recentlyAddedItem.key;
        return !isBundleItem && !isRecentItem;
      });
    },
    get blackFridaySaleSettings() {
      return Alpine.store('blackFridaySale').offerSettings;
    },
    isBlackFridayOfferProduct(item) {
      if (!item) {
        return false;
      }
      const properties = item.properties.attributes;
      return properties.__black_friday_sale && properties.__black_friday_sale.isOfferProduct;
    },
    redirectToItem(item) {
      const lookbookCollection = item.properties.attributes ? item.properties.attributes._lookbook_collection : null;
      if (lookbookCollection) {
        // Check if already collection is lookbook
        if (window.__LIF__.isLookbookCollection) {
          // Just close side card
          Alpine.store('cart').isSideCartOpen = false;
        } else {
          window.location.href = lookbookCollection;
        }
      } else {
        window.location.href = item.url;
      }
    }
  }));

  // custom directives
  Alpine.directive('uppercase', el => {
    el.textContent = el.textContent.toUpperCase()
  });

  Alpine.data('global', () => ({
    init() {
      this.$watch('isSideCartOpen', (isOpen) => {
        setTimeout(() => {
          
          if (!Alpine.store('cart').showUpdateItemPopup) {
            Alpine.store('screen').isScrollableBody = !isOpen;
          }

          const stickyButton = document.getElementById('sticky-add-to-cart');
          if (stickyButton) {
            stickyButton.style.display = isOpen ? 'none': '';
          }
        }, 1000); // Let's wait to close quick add popup
      });

      this.$watch('isIncremementalSaleCompleted', (newValue, previousValue) => {
        // console.log('isIncremementalSaleCompleted: '+this.isIncremementalSaleCompleted);
        if (!previousValue && newValue) {
          Alpine.store('incrementalSale').showSuccessPopup = true;
        }
      });
    },
    get isSideCartOpen() {
      return Alpine.store('cart').isSideCartOpen;
    },
    get isIncremementalSaleCompleted() {
      return Alpine.store('incrementalSale').isCompleted;
    },
    cleanKitProductTitle(title) {
      // Regex pattern to match " - " followed by a number (integer or decimal)
      const pattern = / - \d+(\.\d+)?$/;
      // Using replace to remove the matched pattern     
      const cleanedTitle = title.replace(pattern, "");
      return cleanedTitle;
    },
  }));

  Alpine.data('productRecommendations', () => ({
    maxProductDisplay: 4,

    init() {
      this.$watch('recentlyAddedItem', () => {
        // console.log('productRecommendations: recentlyAddedItem changed.');

        const rec = document.querySelector('product-recommendations');
        if (rec) {
          // console.log('Reloading loadRecommendations...');
          rec.loadRecommendations();
        }
      });
    },

    get recentlyAddedItem() {
      return Alpine.store('cart').recentlyAddedItem
    },
  }));

  Alpine.data('fwpsetPopup', () => ({
    settings: null,
    fwpProduct: null,
    timer: {
      hours: 0,
      minutes: 0,
      seconds: 0,
    },

    init() {
      try {        

        if (Alpine.store('fwpOffer').saleDetails && Alpine.store('fwpOffer').settings) {
          this.settings = Alpine.store('fwpOffer').settings;

          this.startTimer();
          this.loadProduct();
        }

      } catch(error) {
        console.error(error);
      };
    },

    async loadProduct() {

      console.log('-----------------------------------------------------------------------loadProduct: .....');
      console.log(Alpine.store('fwpOffer').productHandle);

      const productHandle = Alpine.store('fwpOffer').productHandle;
      if (productHandle) {
        const resp = await fetch(`https://www.loveinfaith.life/products/${productHandle}?view=json`);
        const response = await resp.json();

        if (response.handle) {
          this.fwpProduct = response;  
        }
      }
    },

    startTimer() {
      this.updateTime();
      setInterval(() => {
        this.updateTime();
      }, 1000);
    },

    updateTime() {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0); // Set midnight as 24:00

      const diff = midnight - now; // Difference in milliseconds
      if (diff > 0) {
        this.timer.hours = Math.floor(diff / 1000 / 60 / 60); // Convert ms to hours
        this.timer.minutes = Math.floor((diff / 1000 / 60) % 60); // Convert ms to minutes
        this.timer.seconds = Math.floor((diff / 1000) % 60); // Convert ms to seconds
      } else {
        this.timer.hours = 0;
        this.timer.minutes = 0;
        this.timer.seconds = 0;
      }
    },
    get hasMultipleColor() {
      if (!this.fwpProduct) {
        return null;
      }
      return !!this.fwpProduct.options.find((o) => o.name.toLowerCase() == 'color' && o.values.length > 1)
    },
    getColorCode(colorName) {
      const colorHandle = colorName.toLowerCase().replace(/\s+/g, '-');
      return this.product.color_values[colorHandle] ? this.product.color_values[colorHandle] : null;
    },

    get ctaColors() {
      if (!this.fwpProduct) {
        return [];
      }
      const ctaColors = this.settings.all.popup_cta_colors;
      return [ctaColors[0].toUpperCase(), ctaColors[1].toUpperCase()];
    },

    get timerBGColor() {
      if (!this.fwpProduct) {
        return null;
      }
      return this.settings.all.countdown_timer_background_color.toUpperCase();
    },
  }));
  
  Alpine.data('pdpCROMessages', () => ({
    previousIndex: null,
    currentIndex: 0,
    messageCount: 0,

    init() {
      window.addEventListener('DOMContentLoaded', () => {
        this.messageCount = document.querySelectorAll('.pdp-cro-message').length;

        setInterval(() => {
          this.previousIndex = this.currentIndex;
          this.currentIndex += 1;

          if (this.currentIndex == this.messageCount) {
            this.currentIndex = 0;
          }
        }, 4000);
      });
    },
  }));

  Alpine.data('userSignup', () => ({
    async login(e) {
      e.preventDefault();

      const loginForm = document.getElementById('customer_login');
      console.log(loginForm);

      this.$refs.errorContainer.innerHTML = '';

      try {
        const res = await fetch(loginForm.getAttribute('action'), {
          method:'post', 
          body: new FormData(loginForm)
        });

        const html = await res.text();
        if (html.includes('Incorrect email or password.')) {
          this.$refs.errorContainer.innerHTML = 'Incorrect email or password.';
        } else {            
          const loginUrl = document.querySelector('[data-login-url]').getAttribute('data-login-url');
          window.location.href = loginUrl;
        }

      } catch (error) {
        console.error(error);
      }

    }
  }));

  Alpine.data('createAccountPopup', () => ({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    password: '',
    errors: {},
    validateForm() {
        this.errors = {};
  
        if (!this.firstName) {
            this.errors.firstName = 'First name is required.';
        }
  
        if (!this.lastName) {
            this.errors.lastName = 'Last name is required.';
        }
  
        if (!this.phoneNumber || this.phoneNumber.length !== 10 || !/^\d{10}$/.test(this.phoneNumber)) {
            this.errors.phoneNumber = 'Phone number must be 10 digits.';
        }
  
        if (!this.password || this.password.length < 8) {
            this.errors.password = 'Password must be at least 8 characters long.';
        }
  
        return Object.keys(this.errors).length === 0;
    },
    submitForm() {
        if (this.validateForm()) {
            // Submit the form if valid
            document.getElementById('create_customer').submit();
        }
    }
  }));
  
  Alpine.data('resetPasswordPopup', () => ({
    newPassword: '',
    confirmNewPassword: '',
    errors: {},
    validateForm() {
        this.errors = {};
  
        if (!this.newPassword || this.newPassword.length < 8) {
            this.errors.newPassword = 'Password must be at least 8 characters long.';
        }

        if (this.newPassword != this.confirmNewPassword) {
            this.errors.confirmNewPassword = 'The password you entered does not match';
        }
  
        return Object.keys(this.errors).length === 0;
    },
    submitForm() {
        if (this.validateForm()) {
            // Submit the form if valid
            document.getElementById('reset_customer_password_modal_form').submit();
             console.log('Reset Password Form Submitted');
        }
    }
  }));
  
  Alpine.data('forgotPasswordPopup', () => ({
    enteredEmail: '', 
    accountExists: false, 
    errorMessage: '', 
    successMessage: '', 
    showEmailErrorMessage: false, 
    showSuccessMessage: false,
    async validateEmail() {
        const email = this.enteredEmail;
        const apiUrl = `${VERIFY_CUSTOMER_EMAIL_API_URL}?email=${email}`;
        
        try {
            const response = await fetch(apiUrl);
            const data = await response.json();

            if (data && data.exists === true) {
                console.log('Account exists:', data.name);
                this.accountExists = true;
                this.successMessage = 'Email Sent. Check your email to reset your password.';
                this.showSuccessMessage = true;
                this.showEmailErrorMessage = false;
                return true;
            } else {
                console.log('Account does not exist');
                this.accountExists = false;
                this.errorMessage = 'Account does not exist with the provided email.';
                this.showEmailErrorMessage = true;
                this.showSuccessMessage = false;
                return false;
            }
        } catch (error) {
            console.error('Error checking account:', error);
            this.errorMessage = 'Error checking account. Please try again later.';
            this.showEmailErrorMessage = true;
            this.showSuccessMessage = false;
            return false;
        }
    },
    async submitResetPasswordForm() {
      event.preventDefault();
      const isValid = await this.validateEmail();
      if (isValid) {
          // Submit the form if valid
          // Instead of redirecting, you can handle the submission here
          const form = document.getElementById('recover_customer_password');
          const formData = new FormData(form);
          formData.append('email', this.enteredEmail);
          
          try {
          const response = await fetch(form.action, {
              method: 'POST',
              body: formData,
          });

          if (response.ok) {
              formData.forEach((value, key) => {
                  console.log(`${key}: ${value}`);
              });
              console.log('Password reset request submitted.');
              this.showResetPasswordSuccessfulModal = true;
              this.showForgotPasswordModal = false;
          } else {
              console.error('Failed to submit password reset request.');
          }
          } catch (error) {
          console.error('Error submitting form:', error);
          }
      }
    }
  }));

  Alpine.data('navbarHeaderMenu', () => ({
    showLoginModal: false, 
    showWelcomeModal: false,
    showEnterPasswordModal: false, 
    showCreateAccountModal: false, 
    showForgotPasswordModal: false,
    showResetPasswordSuccessfulModal: false, 
    showResetPasswordModal: false,
    showEmailErrorMessage: false, 
    enteredEmail: '', 
    errorMessage: '',
    accountExists: false,
    customerName: '',
    captureEmail() { 
        this.enteredEmail = this.$refs.emailInput.value; 
        console.log(this.enteredEmail); // For debugging
    },
    validateEmail() {
        console.log('validateEmail');
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailPattern.test(this.enteredEmail)) {
            console.log('wrongEmail');
            this.errorMessage = 'Please enter a valid email address.';
            this.showEmailErrorMessage = true;
            return false;
        }
        this.errorMessage = '';
        this.showEmailErrorMessage = false;
        this.checkIfAccountExists(); // Check if the account exists
        return true;
    },
    checkForWelcome() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('welcome') === 'true') {
        this.showWelcomeModal = true;
      }
    },
    checkIfAccountExists() {
        const email = this.enteredEmail;
        const apiUrl = `${VERIFY_CUSTOMER_EMAIL_API_URL}?email=${email}`;
        
        fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                if (data && data.exists === true) {
                    console.log('Account exists:', data.name);
                    this.accountExists = true;
                    this.customerName = data.name;
                    this.showEnterPasswordModal = true;  // Show password modal if account exists
                } else {
                    console.log('Account does not exist');
                    this.accountExists = false;
                    this.showCreateAccountModal = true;  // Show create account modal if no account exists
                }
                this.showLoginModal = false;
            })
            .catch(error => {
                console.error('Error checking account:', error);
                this.errorMessage = 'Error checking account. Please try again later.';
                this.showEmailErrorMessage = true;
            });
    }
  }));

  Alpine.data('accountInfo', (addressCount) => ({
    editMyInfo: false, 
    addressCount: addressCount, 
    currentAddressPage: 1, 
    addressPageSize: 2, 
    editAddressInfo: false, 
    addAddressInfo: false, 
    selectedAddress: {},
    myInfoUpdteError: null,

    init() {
      this.$watch('myInfoUpdteError', () => {
        setTimeout(() => {
          this.myInfoUpdteError = null;
        }, 10000);
      });
    },

    updateMyInfo(e) { 
      e.preventDefault();

      const formData = new FormData(e.target);

      const backendURL = STORE_BACKEND_URL || 'https://cron.loveinfaith.work/store-backend-staging';
      fetch(`${backendURL}/customer/updateAccountInfo`, {
        method: 'POST',
        body: formData,
      })
      .then((r) => r.json())
      .then((res) => {

        if (res.status == 'success') {
          this.editMyInfo = false;
          window.location.reload();
        } else {
          this.myInfoUpdteError = res.text;
        }
      });
    }
  }));

  Alpine.data('freeProductTemplate', () => ({
    showSuccessPopup: false,
    init() {
      this.$watch('isUnlocked', (newValue, oldValue) => {
        if (newValue != oldValue && this.isUnlocked) {
          this.showSuccessPopup = true;
        }
      });
    },

    get isUnlocked() {
      return !!Alpine.store('freeProductTemplate').cartAbsoluteFreeProduct 
        && !!Alpine.store('freeProductTemplate').cartFunnelProduct;
    }
  }));
  Alpine.data('blackFridaySale', () => ({
    init() {

      // Auto scroll for mobile view
      if (Alpine.store('screen').isMobile && Alpine.store('blackFridaySale').offerSwitched) {
        setTimeout(() => {
          // document.getElementById('black_friday_offer_tile_2').scrollToView();

          // /* Note: This method is not smooth using scroll-smooth class instead*/
          // const step = 1;
          // let leftPosition = 0;
          // let isReverse = false;
          // let interval = setInterval(() => {
          //   leftPosition = isReverse ? leftPosition - step : leftPosition + step;
          //   // this.$refs.offerTileContainer.scrollLeft = leftPosition;
          //   this.$refs.offerTileContainer.scroll(leftPosition, 0);

          //   if (leftPosition == 200) {
          //     isReverse = true;
          //   }

          //   if (leftPosition == 0) {
          //     // isReverse = false;
          //     clearInterval(interval);
          //   }
          // }, step);

          this.$refs.offerTileContainer.scrollLeft = 300;

          setTimeout(() => {
            this.$refs.offerTileContainer.scrollLeft = 0;
          }, 1000);

        }, 1000);
      }

      const { offers, offerItemsByIndex, saleDetails } = Alpine.store('blackFridaySale');

      // Check if offer collection is loaded even after offer claimed
      for(const [index, offer] of offers.entries()) {
        const offerCollection = '/collections/'+offer.offer_collection;
        if(offerItemsByIndex[index] && window.location.pathname == offerCollection) {
          // Redirect to base collection URL
          window.location.href = saleDetails.targetCollection;
        }
      }

      // console.log('this.activeOffer: ');
      // console.log(this.activeOffer);

      if (this.activeOffer) {
        this.handleActiveOfferChange();
      }

      this.$watch('activeOffer', (newActiveOffer, oldActiveOffer) => {
        console.log('newActiveOffer changed');
        if (!oldActiveOffer && newActiveOffer) {
          setTimeout(() => {
            this.handleActiveOfferChange();
          }, 3000); // let's activate offer amd cart
        }
      });

      this.$watch('bundleItems', (currentBundleItems, previousBundleItems) => {

        const { offers, offerItemsByIndex } = Alpine.store('blackFridaySale');

        // Check if bundle item is added
        if (currentBundleItems.length > previousBundleItems.length) {
          // Track if bundle item threshold met
          for(const offer of offers) {
            const offerCollection = '/collections/'+offer.offer_collection;
            if (this.bundleItems.length == offer.threshold && window.location.pathname != offerCollection) { // Check of page is already on same collection
              // Redirect to offer collection URL
              window.location.href = offerCollection;
            }
          }

        } else if (currentBundleItems.length < previousBundleItems.length) { // Check if bundle item is deleted

          console.log('Bundle item is deleted.');

          // Check if offer threshold expired
          for(const offer of offers) {
            if (currentBundleItems.length < offer.threshold && offerItemsByIndex[offer.index]) { 
              console.log('Going to delete offer item too:');

              // remove offer item too
              const offerItem = offerItemsByIndex[offer.index];
              console.log(offerItem);
              Alpine.store('cart').removeItem(offerItem.key);
            }
          }
        }
      });

      this.$watch('offerItems', (currentOfferItems, previousOfferItems) => {
        // Detect if new offer item added
        if (previousOfferItems.length < currentOfferItems.length) {
          console.log('New offer item added...');

          const { baseURL } = Alpine.store('URL');
          const { targetCollection } = Alpine.store('blackFridaySale').saleDetails;

          let redirectUrl = targetCollection;

          // Check if offer target collection is other than current collection
          if (baseURL != redirectUrl) {
            // Redirect to main collection
            window.location.href = redirectUrl;
          }
        } else if (previousOfferItems.length > currentOfferItems.length) {
          // Offer is deleted redirect to offer collection again for missing offer
          const offerItemsByIndex = Alpine.store('blackFridaySale').offerItemsByIndex;
          for (let i = 0; i < offerItemsByIndex.length; i++)  {
            // Find missing offer
            if (!offerItemsByIndex[i]) {
              // Activate missing offer 
              const activeOffer = Alpine.store('blackFridaySale').offfers[i];

              const offerCollection = '/collections/'+activeOffer.offer_collection;
              if(window.location.pathname != offerCollection) {
                // Redirect to base collection URL
                window.location.href = offerCollection;
              }
            }
          }
        }
      });

    },

    handleActiveOfferChange() {
      // debugger;
      console.log('active offer is fetching..');

      // Check if customer is back to base collection
      const { targetCollection, originalTargetCollection } = Alpine.store('blackFridaySale').saleDetails;
      const { baseURL } = Alpine.store('URL');
      const offerCollection = '/collections/'+this.activeOffer.offer_collection;

      if (!baseURL.endsWith(offerCollection) && (baseURL.endsWith(targetCollection) || baseURL.endsWith(originalTargetCollection))) {
          // Redirect to offer collection URL
          console.log('Going to redirect: ');
          setTimeout(() => {
            window.location.href = offerCollection;
          }, 4000); // to avoid before cart upadte 
      }
    },
    get bgImage() {
      let desktopBannerImage = this.settings.desktop_banner;
      let mobileBannerImage = this.settings.mobile_banner;
      
      // if (this.activeOffer && this.activeOffer.desktop_banner_image && this.activeOffer.mobile_banner_image) {
      //   desktopBannerImage = this.activeOffer.desktop_banner_image;
      //   mobileBannerImage = this.activeOffer.mobile_banner_image;
      // }

      if (this.isStickyHeader) {
        desktopBannerImage = this.settings.desktop_sticky_header_background_image;
        mobileBannerImage = this.settings.mobile_sticky_header_background_image;
      }

      return `--bg-image-desktop: url(${desktopBannerImage}); --bg-image-mobile: url(${mobileBannerImage})`;
    },
    fontClassBySize(size) {
      const classes = {
        Small: 'text-sm md:text-base leading-4',
        Medium: 'text-base md:text-2xl leading-4',
        Large: 'text-lg md:text-3xl leading-4',
      };
      return classes[size] ? classes[size] : 'text-xl leading-4';
    },
    get activeOffer() {
      return Alpine.store('blackFridaySale').activeOffer;
    },
    get bundleItems() {
      return Alpine.store('blackFridaySale').bundleItems;
    },
    get offerItems() {
      return Alpine.store('blackFridaySale').offerItems;
    },
    get settings() {
      return Alpine.store('blackFridaySale').offerSettings;
    },
    get isStickyHeader() {
      return Alpine.store('blackFridaySale').isStickyHeader;
    }
  }));

  Alpine.data('blackFridaySaleCart', () => ({
    get gradientPercentage() {
      const totalBundleItems = this.bundleItemsCount + this.offerItems.length;
      const finalExpectedBundleItemsCount = Alpine.store('blackFridaySale').highestOfferThreshold + this.offers.length;
      if (totalBundleItems == 0) {
        // No items added yet, show initial progress percentage
        return 2;
      }

      // All offer claimed
      if (this.offerItems.length == this.offers.length) {
        return 100;
      }

      // const processPercenatge = (this.offerItems.length / this.offers.length) * 100;
      const percentage = (totalBundleItems / finalExpectedBundleItemsCount) * 100;
      return percentage;
    },
    get bundleItemsCount() {
      return Alpine.store('blackFridaySale').bundleItems.length;
    },
    get settings() {
      return Alpine.store('blackFridaySale').offerSettings;
    },
    get cartSettings() {
      return this.settings.cart_widget_settings;
    },
    get offers() {
      return Alpine.store('blackFridaySale').offers;
    },
    get offerItems() {
      return Alpine.store('blackFridaySale').offerItems;
    },
    get activeOffer() {
      return Alpine.store('blackFridaySale').activeOffer;
    },
    isOfferOver(index) {
      const thisOffer = this.offers[index];

      if (this.bundleItemsCount > thisOffer.threshold) {
        return true;
      }

      return false;
    },
    isOfferActive(index) {
      const thisOffer = this.offers[index];

      if (this.bundleItemsCount == thisOffer.threshold) {
        return true;
      }

      return false;
    },
    isOfferClaimed(index) {
      return !!this.offerItems[index];
    },
    get offersSteps() {
      const steps = [];
      for (let index = 0; index < this.offers.length; index++) {
        steps.push({ type: 'offer', offer: this.offers[index], index });
        
        if (index != this.offers.length - 1) {
          steps.push({ type: 'separator' });
        }
      }

      return steps;
    },
  }));

  Alpine.data('upsellCarousel', () => ({
    isActive: false,
    settings: {},
    currentIndex: 0,
    previousIndex: null,
    flickity: null,

    init() {
      try {
        if (window.__LIF__.upsellSettings) {
          this.settings = window.__LIF__.upsellSettings;
          this.isActive = true;
        }

        this.$watch('isSideCartOpen', (open) => {
          // Check if all content is loaded
          if (open && !this.flickity) {
            setTimeout(() => {
              this.startFlickity();
            }, 100); // Let's wait to load content
          }
        }); 

        setTimeout(() => {
          if (this.isSideCartOpen && !this.flickity) {
            this.startFlickity();
          }
        }, 2000); // Let's wait to load content
      } catch(error) {
        console.error(error);
      };
    },
    get isSideCartOpen() {
      return Alpine.store('cart').isSideCartOpen;
    },
    startFlickity() {
      $('.upsell-group').removeClass('hidden');
      this.flickity = new Flickity('.upsell-group', {
        fade: true,
        imagesLoaded: true,
        contain: true,
        pageDots: false,
        cellAlign: 'left',
        draggable: false,
        groupCells: false,
        wrapAround: false,
        prevNextButtons: false,
      });
    },
    get cartProductIds() {
      return Alpine.store('cart').cartItems.map(p => p.product_id.toString());
    },

    get productChunks() {
      if(!this.isActive) {
        return [];
      }
      
      const products = this.settings.products.filter(p => !this.cartProductIds.includes(p.id.toString()));

      const chunks = [];
      const chunkSize = this.settings.tiles_per_page ? parseInt(this.settings.tiles_per_page) : 3;
      for (let i = 0; i < products.length; i += chunkSize) {
        chunks.push(products.slice(i, i + chunkSize));
      }

      // this.productChunks = 
      return chunks;
    },
    get isSlideAtEnd() {
      if(!this.isActive) {
        return false;
      }
      return this.flickity ? this.flickity.selectedIndex == this.productChunks.length : false;
    },
    get isSlideAtStart() {
      if(!this.isActive) {
        return false;
      }
      return this.flickity ? this.flickity.selectedIndex <= 1 : false;  // Avoid <template> as slide so checking 1 instead of 0
    },
    nextPage() {
      this.flickity.next();
      if (this.flickity.selectedIndex == 1) { // Avoid <template> as slide
        this.flickity.next();
      }

      console.log('this.flickity.selectedIndex: '+this.flickity.selectedIndex);
    },
    previousPage() {
      this.flickity.previous();
    }
  }));

  Alpine.data('upsellCarouselATC', () => ({
    addToCartUpsellCarousel() {
      console.log('addToCartUpsellCarousel: ');
      
      fetch(`/products/${this.product.handle}?view=quick-add`)
      .then((res) => res.text())
      .then((res) => {
        this.$refs.quickAdd.innerHTML = res;
      });
    }
  }));

  Alpine.data('buyMoreSaveMore', (handle) => ({
    isAnyOtherOfferActive: false,
    isBuyMoreActive: false,
    isBuyMoreAdd: false, 
    buyMoreProductHandle: handle,
    buyMoreDiscounts: [],
    highestDiscountQty: 12,

    init() {

      this.isAnyOtherOfferActive = isAnyOfferIsActive();

      if (this.isAnyOtherOfferActive) {
        return false;
      }

      this.$watch('isBuyMoreActive', () => {
        Alpine.store('buyMoreSaveMoreOffer').isActive = this.isBuyMoreActive;
        if (!this.isBuyMoreActive) {
          Alpine.store('buyMoreSaveMoreOffer').pdpSelectedQuantity = 1;
        }
        Alpine.store('sale').init();
      });

      this.$watch('currentDiscountPercentage', () => {
        Alpine.store('buyMoreSaveMoreOffer').currentDiscountPercentage = this.currentDiscountPercentage;
      });

      this.$watch('isHighestDiscountReached', () => {
        Alpine.store('buyMoreSaveMoreOffer').isHighestDiscountReached = this.isHighestDiscountReached;
      });

      this.$watch('buyMoreBundleItemsSplitedQty', () => {
        Alpine.store('buyMoreSaveMoreOffer').buyMoreBundleItemsSplitedQty = this.buyMoreBundleItemsSplitedQty;
      });

      if (this.buyMoreBundleItems.length > 0) {
        this.isBuyMoreActive = true;
      }
    },

    initDiscount(discounts, highestDiscountQty) {

      // this.highestDiscountQty = highestDiscountQty;

      const discountPairs = discounts.split('|');
      for (let discountPair of discountPairs) {
        const [itemCount, discountPercentage] = discountPair.split(':');

        const discount = { 
          itemCount: parseInt(itemCount),
          discountPercentage: parseFloat(discountPercentage)
        };

        this.buyMoreDiscounts.push(discount);

        // if (this.highestDiscountQty < discount.itemCount) {
        //   this.highestDiscountQty = discount.itemCount;
        // }
      }

      Alpine.store('buyMoreSaveMoreOffer').buyMoreDiscounts = this.buyMoreDiscounts;
      Alpine.store('buyMoreSaveMoreOffer').buyMoreBundleItemsSplitedQty = this.buyMoreBundleItemsSplitedQty;
    },

    get isHighestDiscountReached() {
      return this.bundleItemCount >= this.highestDiscountQty;
    },

    get upcomingDiscount() {
      return this.buyMoreDiscounts.find(d => d.itemCount > this.bundleItemCount);
    },

    get currentDiscount() {
      const lowerDiscounts = this.buyMoreDiscounts.filter(d => d.itemCount <= this.bundleItemCount);
      // select most highest qty discount
      return lowerDiscounts.pop();
    },

    get currentDiscountPercentage() {
      if (this.currentDiscount) {
        return this.currentDiscount.discountPercentage;
      }

      return 0;
    },

    get buyMoreBundleItems() {
      return Alpine.store('cart').cartItems.filter((i) => i.properties.attributes.__buy_more_bundle_item);
      // return Alpine.store('cart').cartItems.filter((i) => i.properties.attributes.__buy_more_bundle_item && i.product_handle == this.buyMoreProductHandle);
    },
    get buyMoreBundleItemsSplitedQty() {
      const bundleItems = [];
      for (const item of this.buyMoreBundleItems) {

        // Consider each quantity as seperate bundle item
        for(let i = 0; i < parseInt(item.quantity); i++) {
          bundleItems.push(item)
        }
      }

      return bundleItems;
    },
    get bundleItemCount() {
      // return this.buyMoreBundleItems.length;
      return this.buyMoreBundleItemsSplitedQty.length + Alpine.store('buyMoreSaveMoreOffer').pdpSelectedQuantity;
    },

    get buyMoreOfferPrice() {
      if (!this.product) {
        return null;
      }

      let finalPrice = this.product.variants[0].price / 100;

      if (this.currentDiscountPercentage) {
        const originalPrice = parseFloat(this.product.variants[0].price) / 100;
        const discount = originalPrice * this.currentDiscountPercentage / 100;
        // const discount = originalPrice * this.currentDiscountPercentage / 100;
        finalPrice =  originalPrice - discount;
      }

      return '$'+finalPrice.toFixed(2);
    }
  }));

  Alpine.data('style', (styles) => ({
    styleVars: '',
    styleClasses: '',
    init() {
      this.styleVars = '';
      this.styleClasses = '';

      for (const [key, value] of Object.entries(styles)) {
        switch(key) {
          case 'fontColor': 
            if (value) {
              this.styleVars += `--font-color:${value};`;
              this.styleClasses += ' text-[color:--font-color]';
            }
            break;
          case 'bgColor': 
            if (value) {
              this.styleVars += `--bg-color:${value};`;
              this.styleClasses += ' bg-[color:--bg-color]';
            }
            break;
          case 'bgImage': 
            if (value) {
              this.styleVars += `--bg-image:${value};`;
              this.styleClasses += ' bg-[image:--bg-image]';
            }
            break;
          case 'borderColor': 
            if (value) {
              this.styleVars += `--br-color:${value};`;
              this.styleClasses += ' border-[color:--br-color]';
            }
            break;
          case 'borderImage': 
            if (value) {
              this.styleVars += `--br-image:${value};border-image-slice: 1;`;
              this.styleClasses += ' [border-image:--br-image]';
            }
            break;
          case 'borderWidth': 
            if (value) {
              this.styleVars += `--border-width:${value}px;`;
              this.styleClasses += ' border-[length:--border-width]';
            }
            break;
          case 'borderRounded': 
            if (value) {
              this.styleVars += `--border-rounded:${value}px;`;
              this.styleClasses += ' rounded-[--border-rounded]';
            }
            break;
          case 'width': 
            if (value) {
              this.styleVars += `--width:${value};`;
              this.styleClasses += ' w-[--width]';
            }
            break;
          case 'opacity':
            if (value) {
              this.styleVars += `--opacity:${value / 100};`;
              this.styleClasses += ` opacity-[--opacity] `;
            }
        }
      }
    },
  }));

  Alpine.data('productsCarousel', (elementId) => ({
    isDragging: false,

    init() {
      const flickity = new Flickity('#'+elementId, {
        wrapAround: true,
        imagesLoaded: true
      });

      flickity.on('staticClick', function(event, pointer, cellElement, cellIndex) {
        if (typeof cellIndex === 'number') {
          flickity.select(cellIndex);
        }
      });
    }
  }));
  
  Alpine.data('reviewImageCollection', (handle) => ({
    loadMore(ctaLink) {
      if (ctaLink) {
        window.location.href = ctaLink;
      } else {
        if (document.readyState === 'complete') {
          document.querySelector('.oke-mediaGrid-loadMore')?.click();
        } else {
          window.addEventListener('load', () => {
            document.querySelector('.oke-mediaGrid-loadMore')?.click();
          }, { once: true });
        }
      }
    }
  }));

  Alpine.data('saleHybridColorSwatch', (colorOptionPosition, colorValue, colorHax) => ({
    init() {
      // selectedOptions defined in parent component productTile
      if(this.hasSelectedThisColor) {
        this.setSelectedVariantColorCode(colorHax);
      }
    },
    get hasSelectedThisColor() {
      return this.selectedOptions[colorOptionPosition] == colorValue;
    },

    selecteThisColor(variantImage) {
      this.mainImage = variantImage;
      this.selectOption(colorOptionPosition, colorValue)
    }

  }));

  Alpine.data('confirmBundle', (mainProductId, firstAddOnProductId, handle, discountValue) => ({
    confirmBundleIsActive: true,
    selectedBundleColor: null,
    addOnProductId: firstAddOnProductId,
    selectedAddOnProductType: 'Sweat Shorts',
    selectedBundleProductVariant: null,
    selectedBundleAddOnVariant: null,
    // preorderVariants: [],
    selectedPreOrderVariant: null,

    init() {
      // if (document.querySelector('#product_'+handle+'_preorder[type="application/json"]')) {
      //   this.preorderVariants = JSON.parse(document.querySelector('#product_'+handle+'_preorder[type="application/json"]').textContent);
      // }

      this.$watch('selectedBundleColor', (newColor) => {

        // Use only color prefix
        const colorParts = newColor.split('-');

        window.dispatchEvent(new CustomEvent('confrm-bundle--variant-color-changed', {
          detail: { newColor: colorParts[0].trim() }
        }));
      });

      // this.$watch('selectedBundleProductVariant', (selectedVariant) => {
      //   // console.log(n);

      //   console.log('selectedBundleProductVariant: ');
      //   console.log(selectedVariant);

      //   if (!selectedVariant) {
      //     this.selectedPreOrderVariant = null;
      //     return;
      //   }

      //   const preorderVariant = this.preorderVariants.find(v => v.variant_id == selectedVariant.id && !!v.pre_order_variant);

      //   // Check if pre order is defined and qty is available
      //   if (!preorderVariant || !preorderVariant.pre_order_variant.is_available) {
      //     this.selectedPreOrderVariant = null;
      //     return;
      //   }

      //   // Copy pre_order_variant
      //   const pre_order_variant = { ...preorderVariant.pre_order_variant };

      //    // Split manually to avoid timezone effect
      //   const [year, month, day] = pre_order_variant.est_date.trim().split('-').map(Number);

      //   // Month names
      //   const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      //   let formattedEST = '';
      //   if (month && day) {
      //     formattedEST = `${months[month - 1]} ${day}`;
      //   }

      //   pre_order_variant.est_date = formattedEST;

      //   this.selectedPreOrderVariant = pre_order_variant;
      // });

      // this.$watch('selectedBundleProductVariant', (newVariant) => {
        
      // });
    },

    get shouldShowSecondaryATCButton() {
      if (this.isSelectedVariantOOS) {
        return false;
      }

      const bundleStores = Alpine.store('bundleStore').bundles;      
      const mainProduct = bundleStores.find(b => b.product.id == mainProductId);
      const addOnProduct = bundleStores.find(b => b.product.id == this.addOnProductId);
      
      if (!mainProduct || !addOnProduct) {
        return false;
      }

      // Any one bundle product having secondary ATC
      return [mainProduct, addOnProduct].every(s => {
        return s.product.metafields.enabled_secondary_atc_button 
        && s.selectedVariant.metafields.secondary_atc_discounted_price
      });
    },

    getBundleDiscountedPrice(productId) {
      // const productPrice = document.querySelector('#bundle_discount_price_'+productId);
      // return parseFloat(productPrice.value);
      
      const bundleStores = Alpine.store('bundleStore').bundles;
      const thisProduct = bundleStores.find(b => b.product.id == productId);

      const thisProductPrice = thisProduct.selectedVariant.price;
      const thisProductPriceBundleDiscount = thisProduct.selectedVariant?.metafields?.glo_bundle_discount_value ?? 0;

      if (thisProductPriceBundleDiscount && thisProductPriceBundleDiscount > 0) {
        return (thisProductPrice - (thisProductPriceBundleDiscount * 100))
      }

      return thisProductPrice;
    },

    getBundleSecondaryDiscountedPrice(productId) {
      // const productPrice = document.querySelector('#bundle_discount_price_'+productId);
      // return parseFloat(productPrice.value);
      
      const bundleStores = Alpine.store('bundleStore').bundles;
      const thisProduct = bundleStores.find(b => b.product.id == productId);

      const thisProductPrice = thisProduct.selectedVariant.price;
      let thisProductSecondaryPrice = thisProduct.selectedVariant?.metafields?.secondary_atc_discounted_price ?? 0;

      if (thisProductSecondaryPrice) {
        thisProductSecondaryPrice = thisProductSecondaryPrice * 100;
      } else {
        thisProductSecondaryPrice = thisProductPrice;
      }

      // COMMENTED UPDATE: Bundle discount to not be deducted for second ATC.
      // const thisProductPriceBundleDiscount = thisProduct.selectedVariant?.metafields?.glo_bundle_discount_value ?? 0;

      // if (thisProductPriceBundleDiscount && thisProductPriceBundleDiscount > 0) {
      //   return (thisProductSecondaryPrice - (thisProductPriceBundleDiscount * 100))
      // }

      return thisProductSecondaryPrice;
    },

    getPreOrderBundleDiscountedPrice(productId) {
      const productPrice = document.querySelector('#pre_order_bundle_discount_price_'+productId);
      return parseFloat(productPrice.value) * 100;
    },
    getBundleProductEstDate(productId) {
      const productPrice = document.querySelector('#bundle_est_date_'+productId);
      return productPrice.value;
    },

    // get selectedBundleColorCode() {
    //   if (window.__LIF__.kingdom_color_variants_matadata) {
    //     const colorMetaObject = window.__LIF__.kingdom_color_variants_matadata.find(v => v.color_variant_name == this.selectedBundleColor);

    //     if (colorMetaObject) {
    //       return colorMetaObject.variant_color_code;
    //     }
    //   }

    //   return '#000000';
    // },
    get selectedPreOrderVariant() {
      if (!this.selectedBundleProductVariant || !this.selectedBundleProductVariant.pre_order_variant || !this.selectedBundleProductVariant.pre_order_variant.is_available) {
        return null;
      }

      if (!this.selectedBundleAddOnVariant || !this.selectedBundleAddOnVariant.pre_order_variant || !this.selectedBundleAddOnVariant.pre_order_variant.is_available) {
        return null;
      }

      const pre_order_variant = { ...this.selectedBundleProductVariant.pre_order_variant };

      // Split manually to avoid timezone effect
      const [year, month, day] = pre_order_variant.est_date.trim().split('-').map(Number);

      // Month names
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      let formattedEST = '';
      if (month && day) {
        formattedEST = `${months[month - 1]} ${day}`;
      }

      pre_order_variant.est_date = formattedEST;
      return pre_order_variant;
    },
    get selectedPreOrderAddOnVariant() {
      if (!this.selectedBundleAddOnVariant || !this.selectedBundleAddOnVariant.pre_order_variant || !this.selectedBundleAddOnVariant.pre_order_variant.is_available) {
        return null;
      }

      return this.selectedBundleAddOnVariant.pre_order_variant;
    },
    setAddOn(event, productId) {
      this.addOnProductId = event.target.checked ? productId : null;
    },

    toggleAddOn(productId) {
      this.addOnProductId = this.addOnProductId == productId ? null : productId;
    },

    get isSelectedVarianQtyZero() {
      const selectedVariant = this.selectedBundleProductVariant;
      if (!selectedVariant) {
        return false;
      }

      return selectedVariant.remaining_quantity <= 0;
    },

    get isSelectedVariantOOS() {
      const selectedVariant = this.selectedBundleProductVariant;
      if (!selectedVariant) {
        return true;
      }

      const selectedBundleProductOOS = selectedVariant.remaining_quantity <= 0 && selectedVariant.inventory_policy != 'continue';

      const selectedVariantAddOn = this.selectedBundleAddOnVariant;
      if (!selectedVariantAddOn) {
        return selectedBundleProductOOS;
      }

      const selectedBundleAddOnOOS = selectedVariantAddOn.remaining_quantity <= 0 && selectedVariantAddOn.inventory_policy != 'continue';
      return selectedBundleProductOOS || selectedBundleAddOnOOS;
    },

    // availablePreOrderVariant() {
    //   // debugger;
    //   if (!this.selectedBundleProductVariant) {
    //     return false;
    //   }

    //   return this.preorderVariants.find(v => v.variant_id == this.selectedBundleProductVariant.id && !!v.pre_order_variant);
    // },
    // getPreOrderDiscountedPrice(discountAmount) {

    //   const preOrderVariant = this.availablePreOrderVariant();
    //   const preOrderVariantPrice = parseFloat(preOrderVariant.pre_order_variant.price.replace('$', ''));

    //   return preOrderVariantPrice - discountAmount;
    // },

    addBundleToCart() {
      if (!this.selectedBundleProductVariant) {
        console.log('No variant is selecetd.');
        return;
      }

      const mainProductPrice = this.getBundleDiscountedPrice(mainProductId);
      const addOnProductPrice = this.getBundleDiscountedPrice(this.addOnProductId);
      
      const lastBundleIndex = this.getLastBundleIndex();
      const sameBundleIndex = this.getSameVariantBundleIndex();

      const mainCartItem = this.createBundleCartItem(this.selectedBundleProductVariant.id, mainProductPrice, lastBundleIndex, sameBundleIndex);
      const addOnCartItem = this.createBundleCartItem(this.selectedBundleAddOnVariant.id, addOnProductPrice, lastBundleIndex, sameBundleIndex);

      Alpine.store('cart').addItems([mainCartItem, addOnCartItem], () => {
        Alpine.store('cart').isCartInProgress = false;
      });
    },

    secondaryAddToCart() {
      if (!this.selectedBundleProductVariant) {
        console.log('No variant is selecetd.');
        return;
      }

      const mainProductPrice = this.getBundleSecondaryDiscountedPrice(mainProductId);
      const addOnProductPrice = this.getBundleSecondaryDiscountedPrice(this.addOnProductId);
      
      const lastBundleIndex = this.getLastBundleIndex();
      const sameBundleIndex = this.getSameVariantBundleIndex(this.secondaryAtcEdd);

      const mainCartItem = this.createBundleSecondaryCartItem(this.selectedBundleProductVariant.id, mainProductPrice, lastBundleIndex, sameBundleIndex);
      const addOnCartItem = this.createBundleSecondaryCartItem(this.selectedBundleAddOnVariant.id, addOnProductPrice, lastBundleIndex, sameBundleIndex);

      Alpine.store('cart').addItems([mainCartItem, addOnCartItem], () => {
        Alpine.store('cart').isCartInProgress = false;
      });
    },

    get totalBundlePrice() {
      if (!this.getBundleDiscountedPrice) {
        return null;
      }

      const mainProductPrice = this.getBundleDiscountedPrice(mainProductId);
      const addOnProductPrice = this.getBundleDiscountedPrice(this.addOnProductId);

      return ((mainProductPrice + addOnProductPrice) / 100);
    },
    get totalSecondaryATCBundlePrice() {
      if (!this.getBundleSecondaryDiscountedPrice) {
        return null;
      }

      const mainProductPrice = this.getBundleSecondaryDiscountedPrice(mainProductId);
      const addOnProductPrice = this.getBundleSecondaryDiscountedPrice(this.addOnProductId);

      return ((mainProductPrice + addOnProductPrice) / 100);
    },
    get totalPreOrderBundlePrice() {

      // fetch Pre order product
      // const mainProductPreOrder = JSON.parse(document.querySelector(`#product_${mainProductId}_preorder`).innerHTML);
      // const addOnProductPreOrder = JSON.parse(document.querySelector(`#product_${this.addOnProductId}_preorder`).innerHTML);

      const productPrice = document.querySelector('#pre_order_bundle_discount_price_'+mainProductId);
      const preOrderBundleDiscountedPrice = parseFloat(productPrice.value) * 100;

      let mainProductPrice = preOrderBundleDiscountedPrice;

      if (this.selectedPreOrderVariant) {
        const selectedPreOrderVariantPrice = parseFloat(this.selectedPreOrderVariant.price);
        const selectedPreOrderVariantDiscount = parseFloat(this.selectedPreOrderVariant.metafields.glo_bundle_discount_value || 0);

      // Get bundle discounted price
        mainProductPrice = (selectedPreOrderVariantPrice - selectedPreOrderVariantDiscount) * 100
      }

      let addOnProductPrice = 0;

      // const addOnProductPrice = this.getPreOrderBundleDiscountedPrice(this.addOnProductId);

      if (this.selectedPreOrderAddOnVariant) {
        const selectedPreOrderAddOnVariantPrice = parseFloat(this.selectedPreOrderAddOnVariant.price);
        const selectedPreOrderAddOnVariantDiscount = parseFloat(this.selectedPreOrderAddOnVariant.metafields.glo_bundle_discount_value || 0);

        addOnProductPrice = (selectedPreOrderAddOnVariantPrice - selectedPreOrderAddOnVariantDiscount) * 100 
      }

      return (mainProductPrice + addOnProductPrice) / 100;
    },
    addPreOrderToCart(estDate) {

      if (!this.selectedBundleProductVariant) {
        console.log('No variant is selecetd.');
        return;
      }

      // const mainProductPrice = this.getPreOrderBundleDiscountedPrice(mainProductId);

      const mainProductPrice = (parseFloat(this.selectedPreOrderVariant.price) - parseFloat(this.selectedPreOrderVariant.metafields.glo_bundle_discount_value || 0)) * 100;
      // const addOnProductPrice = this.getPreOrderBundleDiscountedPrice(this.addOnProductId);
      const addOnProductPrice = (parseFloat(this.selectedPreOrderAddOnVariant.price) - parseFloat(this.selectedPreOrderAddOnVariant.metafields.glo_bundle_discount_value || 0)) * 100;
      
      const lastBundleIndex = this.getLastBundleIndex();
      const sameBundleIndex = this.getSameVariantPreOrderBundleIndex();

      
      // const selectedPreOrderVariant = this.preorderVariants.find(v => v.variant_id == this.selectedBundleProductVariant.id && !!v.pre_order_variant);

      // if (!selectedPreOrderVariant) {
      //   return false;
      // }

      const mainCartItem = this.createBundleCartItem(this.selectedPreOrderVariant.id, mainProductPrice, lastBundleIndex, sameBundleIndex);
      const addOnCartItem = this.createBundleCartItem(this.selectedPreOrderAddOnVariant.id, addOnProductPrice, lastBundleIndex, sameBundleIndex);

      // if (mainCartItem.properties.__estimated_delivery_date)
      //   delete mainCartItem.properties.__estimated_delivery_date;

      // if (addOnCartItem.properties.__estimated_delivery_date)
      //   delete addOnCartItem.properties.__estimated_delivery_date;

      // Add EST date line item property
      mainCartItem.properties.PreOrder = this.selectedPreOrderVariant.est_date;
      addOnCartItem.properties.PreOrder = this.selectedPreOrderVariant.est_date;

      Alpine.store('cart').addItems([mainCartItem, addOnCartItem], () => {
        Alpine.store('cart').isCartInProgress = false;
      });
      
    },
    getLastBundleIndex() {
      let lastBundleIndex = -1;

      // find bundle index
      const bundleItems = Alpine.store('cart').cartItems.filter((i) => i.properties.attributes.__glo_bundle);
      for (let bundleItem of bundleItems) {
        const bundleIndex = bundleItem.properties.attributes.__glo_bundle.bundleIndex;
        if (lastBundleIndex < bundleIndex) {
          lastBundleIndex = bundleIndex;
        }
      }

      return lastBundleIndex;
    },

    getSameVariantBundleIndex(orderEST = null) {
      let sameBundleIndex = null;

      const sameVariantBundle = this.bundleItemCollection.find(b => {
        const isSameProductVariant = b[0].variant_id == this.selectedBundleProductVariant.id;
        const isSameAddOnVariant = b[1].variant_id == this.selectedBundleAddOnVariant.id;
        const isSameEST = orderEST ? b[0].properties.attributes.SecodaryOrderEST == orderEST : !b[0].properties.attributes.SecodaryOrderEST

        return isSameProductVariant && isSameAddOnVariant && isSameEST;
      });
      if (sameVariantBundle) {
        const bundleItem = sameVariantBundle[0];
        sameBundleIndex = bundleItem.properties.attributes.__glo_bundle.bundleIndex
      }

      return sameBundleIndex;
    },

    getSameVariantPreOrderBundleIndex(orderEST = null) {
      let sameBundleIndex = null;

      const sameVariantBundle = this.bundleItemCollection.find(b => {
        const isSameProductVariant = b[0].variant_id == this.selectedPreOrderVariant.id;
        const isSameAddOnVariant = b[1].variant_id == this.selectedPreOrderAddOnVariant.id;

        return isSameProductVariant && isSameAddOnVariant;
      });
      if (sameVariantBundle) {
        const bundleItem = sameVariantBundle[0];
        sameBundleIndex = bundleItem.properties.attributes.__glo_bundle.bundleIndex
      }

      return sameBundleIndex;
    },

    get bundleItemCollection() {
      const bundleItems =  Alpine.store('cart').cartItems.filter((i) => i.properties.attributes.__glo_bundle);

      // Group by bundle index
      const bundleItemGroups = {};
      for(let bundleItem of bundleItems) {
        const bundleIndex = bundleItem.properties.attributes.__glo_bundle.bundleIndex;

        if (!bundleItemGroups[bundleIndex]) {
          bundleItemGroups[bundleIndex] = [];
        }

        bundleItemGroups[bundleIndex].push(bundleItem);
      }

      return Object.values(bundleItemGroups).reverse();
    },

    createBundleCartItem(variantId, price, lastBundleIndex, sameBundleIndex = null) {
      const eddStore = Alpine.store('edd') || {};
      const { eddDateText, daysInTransit } = eddStore;
      return {
        id: variantId,
        quantity: 1,
        properties: {
          __winter_bundle_sale_fixed_price: { 
              type: 'FIXED', 
              price: price,
              saleName: 'Kingdom Essential Bundle'
          },
          __glo_bundle: {
            bundleIndex: sameBundleIndex !== null ? sameBundleIndex : lastBundleIndex + 1
          },
          ...(eddDateText && daysInTransit && {
            __estimated_delivery_date: eddDateText
          })
        } 
      }
    },
    createBundleSecondaryCartItem(variantId, price, lastBundleIndex, sameBundleIndex) {
      const { eddDateText, daysInTransit } = Alpine.store('edd');

      return {
        id: variantId,
        quantity: 1,
        properties: {
          __winter_bundle_sale_fixed_price: { 
              type: 'FIXED', 
              price: price,
              saleName: 'Kingdom Essential Pre-Order Bundle'
          },
          __glo_bundle: {
            bundleIndex: sameBundleIndex !== null ? sameBundleIndex : lastBundleIndex + 1
          },
          SecodaryOrderEST: this.secondaryAtcEdd,
          ...(eddDateText && daysInTransit && {
            __estimated_delivery_date: eddDateText
          })
        }
      }
    }
  }));

  Alpine.data('preOrder', (handle) => ({
    // preOrderProduct: null,
    // preorderVariants: [],
    // selectedPreOrderVariant: null,
    init() {
      // if (document.querySelector('#product_'+handle+'_preorder[type="application/json"]')) {
      //   this.preorderVariants = JSON.parse(document.querySelector('#product_'+handle+'_preorder[type="application/json"]').textContent);
      // }

      // this.$watch('selectedVariant', (selectedVariant) => {
      //   // console.log(n);

      //   console.log('selectedVariant: ');
      //   console.log(selectedVariant);

      //   // debugger;
      //   if (!selectedVariant) {
      //     this.selectedPreOrderVariant = null;
      //     return;
      //   }

      //   const preorderVariant = this.preorderVariants.find(v => v.variant_id == selectedVariant.id && !!v.pre_order_variant);

      //   // Check if pre order is defined and qty is available
      //   if (!preorderVariant || !preorderVariant.pre_order_variant.is_available) {
      //     this.selectedPreOrderVariant = null;
      //     return;
      //   }

      //   // Copy pre_order_variant
      //   const pre_order_variant = { ...preorderVariant.pre_order_variant };

      //   // Split manually to avoid timezone effect
      //   const [year, month, day] = pre_order_variant.est_date.trim().split('-').map(Number);

      //   // Month names
      //   const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      //   let formattedEST = '';
      //   if (month && day) {
      //     formattedEST = `${months[month - 1]} ${day}`;
      //   }

      //   pre_order_variant.est_date = formattedEST;

      //   this.selectedPreOrderVariant = pre_order_variant;
      // });
    },
    get selectedPreOrderVariant() {
      if (!this.selectedVariant || !this.selectedVariant.pre_order_variant || !this.selectedVariant.pre_order_variant.is_available) {
        return null;
      }

      const pre_order_variant = { ...this.selectedVariant.pre_order_variant };

      // Split manually to avoid timezone effect
      const [year, month, day] = pre_order_variant.est_date.trim().split('-').map(Number);

      // Month names
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      let formattedEST = '';
      if (month && day) {
        formattedEST = `${months[month - 1]} ${day}`;
      }

      pre_order_variant.est_date = formattedEST;
      return pre_order_variant;
    },

    shouldShowSecondaryATCButton() {
      return !this.isSelectedVariantOOS 
        && this.product.metafields.enabled_secondary_atc_button 
        && this.selectedVariant.metafields.secondary_atc_discounted_price
        && !this.selectedPreOrderVariant;
    },

    get secondaryAtcEdd() {
      // + 14 days of current date
      const date = new Date();
      let addedDays = 0;

      while (addedDays < 14) {
        date.setDate(date.getDate() + 1);

        const day = date.getDay();
        if (day !== 0 && day !== 6) { // 0 = Sunday, 6 = Saturday
          addedDays++;
        }
      }

      const formatted = date.toLocaleDateString('en-US', {
        timeZone: "America/Los_Angeles",
        month: 'short',
        day: 'numeric'
      });

      return formatted;
    },

    secondaryAddToCart() {

      const variantId = this.selectedVariant.id;
      const price = this.selectedVariant.metafields.secondary_atc_discounted_price;

      const { eddDateText, daysInTransit } = Alpine.store('edd');
      const item = {
        id: variantId,
        quantity: 1,
        properties: {
          __winter_bundle_sale_fixed_price: { 
              type: 'FIXED', 
              price: parseFloat(price) * 100,
              saleName: 'PRE-ORDER'
          },
          SecodaryOrderEST: this.secondaryAtcEdd,
          ...(eddDateText && daysInTransit && {
            __estimated_delivery_date: eddDateText
          })
        }
      }

      Alpine.store('cart').addItems([item], () => {
        Alpine.store('cart').isCartInProgress = false;
      });
    },

    // availablePreOrderVariant(selectedVariant) {
    //   // debugger;
    //   if (!selectedVariant) {
    //     return false;
    //   }

    //   return this.preorderVariants.find(v => v.variant_id == selectedVariant.id && !!v.pre_order_variant);
    // },
    addPreOrderToCart() {

      // const selectedPreOrderVariant = this.preorderVariants.find(v => v.variant_id == this.selectedVariant.id && !!v.pre_order_variant);

      // if (!selectedPreOrderVariant) {
      //   return;
      // }

      // console.log('addPreOrderToCart');
      // console.log(this.selectedOptions);

      // // get selected main product size
      // const selectedSize = this.selectedOptions[this.optionIndex.size + 1];
      // const selectedColor = this.selectedOptions[this.optionIndex.color + 1];

      // // Now get BB variant of same size
      // const sizeOption = this.preOrderProduct.options.find(o => o.name.toLowerCase() == 'size');
      // const colorOption = this.preOrderProduct.options.find(o => o.name.toLowerCase() == 'color');

      // const selectedSizePreVariant = this.preOrderProduct.variants.find(v => v['option'+sizeOption.position] == selectedSize && v['option'+colorOption.position] == selectedColor);

      // if (!selectedSizePreVariant) {
      //   console.log('No Pre Order variant found for selected size.');
      //   return;
      // }

      // this.selectedVariant;

      // console.log(selectedSizePreVariant);


      const { eddDateText, daysInTransit } = Alpine.store('edd');

      const item = {
        id: this.selectedPreOrderVariant.id,
        quantity: this.itemQty,
        properties: {
          // __winter_bundle_sale_fixed_price: { 
          //     type: 'FIXED', 
          //     price: parseFloat(preOrderPrice) * 100,
          //     saleName: 'Pre Order'
          // },
          PreOrder: this.selectedPreOrderVariant ? this.selectedPreOrderVariant.est_date : null,
          ...(eddDateText && daysInTransit && {
            __estimated_delivery_date: eddDateText
          })
        }
      }      
      
      this.quickAddIndex = null;
      Alpine.store('collectionLookbook').quickAddProductHandle = null;
      
       Alpine.store('cart').addItems([item], () => {
        Alpine.store('cart').isCartInProgress = false;
      });
      
    }

  }));

   Alpine.data('sizeGuide', () => ({
    isExpanded: false, 
    isSizeGuideOpen: false,
    init() {
      this.$watch('isSizeGuideOpen', (isOpen) => {
        Alpine.store('screen').isScrollableBody = !isOpen;
      }); 
    },
    openSizeGuide() {
      this.isSizeGuideOpen = true;
      Alpine.store('pdp').isSizeGuideOpen = true;
    },
    closeSizeGuide() {
      this.isSizeGuideOpen = false;
      Alpine.store('pdp').isSizeGuideOpen = false;
    }
  }));

  Alpine.data('lifInstagram', (numberOfItems, mediaType) => ({
    instaVideos: [],
    instaRandomVideos: [],
    instaPhotos: [],
    init() {
      const accessToken = 'IGAAP8xdzN0mlBZAFlraUhkTEt2LV9kaVUtZA0xuNF9nZAzJiQlJVdHNsT3NPMVlXcDdTSlNhQlp4eXJJaXZATZAjFkWUo2aXRyMERwakthdWZAIMllRRXpnVVl5UDJXeWhFNjZAoUGQ4Mkc4RURBdGhXYlhCMmNYRkdnY0hZAdWJGOXBSbwZDZD'; // Replace with your access token
      const limit = 100; // Number of posts to fetch
      const apiUrl = `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url&access_token=${accessToken}&limit=${limit}`;

      fetch(apiUrl)
        .then(response => response.json())
        .then(response => {
          console.log(response);
          this.instaVideos = response.data.filter(d => d.media_type == 'VIDEO').slice(0, numberOfItems);
          this.instaPhotos = response.data.filter(d => d.media_type == 'IMAGE').slice(0, numberOfItems);

          let shuffled = this.instaVideos.slice(); // create a shallow copy
          for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]; // swap
          }
          this.instaRandomVideos = shuffled.slice(0, 5);

          if (this.$refs.slides) {
            setTimeout(() => {
              const flktySettings = {
                groupCells: true,
                groupCells: Alpine.store('screen').isMobile ? 1 : 5,
                cellAlign: mediaType == 'video' && Alpine.store('screen').isMobile  ? 'center' : 'left',
                // contain: true,
                // cellAlign: 'center',
                imagesLoaded: true,
              }
              const thisFlickity = new Flickity(this.$refs.slides, flktySettings);

              if (Alpine.store('screen').isMobile) {
                // Move centered element to left initially
                thisFlickity.select(1);
              }
            }, 3000);
          }
        });
      }
  }));

  Alpine.data('collectionLookbook', (editionColor, productHandle, hasTileCover, sliderEffect = "fade") => ({
    productImages: [],
    swiperInstance: null,
    shouldProductImageShow: false,
    quickAddIndex: null,
    hoverTriggered: false,
    showQuickAdd: false,
    
    init() {

      // debugger;
      // console.log(productHandle);
      // console.log('product_'+productHandle+'_lookbook_media');
      // console.log(document.querySelector('#product_'+productHandle+'_lookbook_media[type="application/json"]'));

      const mediaDataElement = document.querySelector('#product_'+productHandle+'_media[type="application/json"]');

      if (mediaDataElement) {
        const allProductMedia = JSON.parse(mediaDataElement.textContent);
        
        this.productImages = [];
        // debugger;

        allProductMedia.filter(m => m.alt == editionColor).forEach((media, index) => {

          // If there is no Tile color then skip the first image to show on slide 
          // because we using first image as cover image
          if (!hasTileCover && index == 0) {
            return;
          }
          this.productImages.push(media);
        });
        
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    },
    initSwiper() {
      const el = this.$el.querySelector('.lookbook-swiper');

      if (!el || this.productImages.length <= 1 || this.swiperInstance) return;

      if (el.swiper) {
        el.swiper.destroy(true, true);
      }

      this.swiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        speed: sliderEffect == 'slide' ? 500 : 300,
        effect: sliderEffect,
        on: {
          touchStart: () => {
            this.isUserInteracted = true;
          },
          slideChange: () => {
            this.isUserInteracted = true;
          }
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        virtual: {
          addSlidesBefore: 1,
          addSlidesAfter: 1
        },
      });
    },
    onHover() {
      if (!this.swiperInstance) {
        this.initSwiper();
      }
      if (this.swiperInstance && this.productImages.length > 1) {
        this.hoverTriggered = true;
        this.swiperInstance.slideToLoop(0, this.productImages.length);
      }
    },
    onLeave() {
      // if (this.swiperInstance && this.hoverTriggered) {
      //   this.swiperInstance.slideToLoop(0, this.productImages.length);
      // }

      this.hoverTriggered = false;
    },
    quickAdd() {
      Alpine.store('collectionLookbook').quickAddProductHandle = productHandle;
      Alpine.store('collectionLookbook').quickAddProductEditionColor = editionColor;
    }
  }));
  
  Alpine.data('skuMatchUpsellV2', () => ({
    upsellProducts: [],
    loadedUpsellProductIndexes: [],
    mySwiper: null,
    shouldRenderNow: false,
    newProductHandles: [],
    isNewProducts: false,
    isNewProductLoaded: false,

    init() {

      if (window.__LIF__._skuMatchUpsellV2.newProductHandles && window.__LIF__._skuMatchUpsellV2.newProductHandles.length > 0) {
        window.__LIF__._skuMatchUpsellV2.newProductHandles.forEach((newProductHandle) => {
          this.newProductHandles.push({
            newProductHandle
          });
        });
      }

      if (this.cartItems) {
        this.loadAddOnProducts();
        console.log('loadAddOnProducts 1.');
      }

      this.$watch('cartItemsLength', (currentLength, oldLength) => {
        console.log('cartItemsLength changed: currentLength: '+currentLength+', oldLength:'+oldLength);

        if (currentLength != oldLength) {
          this.loadAddOnProducts();
        }
      });

      // this.$watch('recentlyAddedItem', async (newItem, oldItem) => {
      //   if ((oldItem && !newItem) || (!oldItem && newItem) || newItem.key != oldItem.key) {
      //     this.loadAddOnProducts();
      //   }
      // });

      this.$watch('isSideCartOpen', (isOpen) => {
        if (isOpen) {
          setTimeout(() => {
            this.shouldRenderNow = true;
          }, 300);
        } else {
          this.shouldRenderNow = false;
        }
      });
    },

    reinitializeSlider() {
      if (this.mySwiper) {
        this.mySwiper.destroy(true, true);
      }

      this.mySwiper = new Swiper('.swiper-container-upsell-v2', {
        loop: false,
        slidesPerView: 1.3,
        spaceBetween: 10,
        speed: 800,
        autoplay: false,
        currentIndex: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    },

    async loadAddOnProducts() {

      console.log('loadAddOnProducts called.');

      // debugger;

      this.upsellProducts = [];
      
      if (this.cartItems.length > 0) {
        this.cartItems.forEach(i => {
          if (i.add_on_products && i.add_on_products.length > 0 && i.add_on_products[0].is_available) {

            const cartItemSelectedColor = i.option_values.color.value;
            const addOnProduct = i.add_on_products[0];

            // Check if add-on is already added in cart
            const existingCartItem = this.cartItems.find(item => item.product_id == addOnProduct.id && item.option_values.color && matchedSplitedColorName(item.option_values.color.value, cartItemSelectedColor));
            const existingUpsell = this.upsellProducts.find(u => u.product.id == addOnProduct.id && u.selectedColor == cartItemSelectedColor);

            if (!existingCartItem && !existingUpsell) {

              // Check selected color is avaliable
              const availableColorNames = addOnProduct.available_colors.split(',');
              if (matchedSplitedColorNames(availableColorNames, cartItemSelectedColor)) {
                this.upsellProducts.push({
                  selectedColor: cartItemSelectedColor ?? null,
                  product: addOnProduct,
                });
              }
            }
          }
        });

        // Reverse to match cart items orders
        this.upsellProducts = this.upsellProducts.reverse();
        this.isNewProducts = false;
      } else {

        // cart is empty
        this.upsellProducts = [ ...this.newProductHandles ];
        this.isNewProducts = true;

        // Check if new products are already loaded then skip to load again
        if (this.isNewProductLoaded) {
          return;
        }
      }

      // debugger;

      this.selectedHoodieColor = this.recentlyAddedItem ? this.recentlyAddedItem.option_values.color.value : null;

      let matchedColorFound = false;

      // Validate color match
      for(let i = 0; i < 4; i++) {

        if (!this.upsellProducts[i]) {
          continue;
        }

        let selectedColor = null;

        if (this.upsellProducts[i].product) {
          const upcellProduct = this.upsellProducts[i].product;
          selectedColor = this.upsellProducts[i].selectedColor;

          let colorAvailable = false;
          const colorOption = upcellProduct.options.find(o => o.name.toLowerCase() == 'color');

          // Check if upsellProduct having selected color
          if (colorOption) {
            // const colorName = selectedColor.split("-").pop().trim();

            // if (colorOption.values.includes(colorName) || colorOption.values.some(c => {
            //   const lastPart = c.split("-").pop().trim();
            //   return lastPart == colorName;
            // })) {
            if (matchedSplitedColorNames(colorOption.values, selectedColor)) {
              matchedColorFound = true;
            }
          }
        }
      }

      // If no color matched product found then show new products
      if (!matchedColorFound) {
        this.upsellProducts = [ ...this.newProductHandles ];

        this.isNewProducts = true;

        // Check if new products are already loaded then skip to load again
        if (this.isNewProductLoaded) {
          return;
        }

      } else {
        this.isNewProducts = false;
      }

      this.loadedUpsellProductIndexes = [];

      for(let i = 0; i < 4; i++) {

        if (!this.upsellProducts[i]) {
          const upsellProductsContainer = document.getElementById('sku_match_upsell_products_product_'+(i+1));

          if (upsellProductsContainer) {
            // Reset upsell product if already rendered
            upsellProductsContainer.innerHTML = '';
          }
          continue;
        }

        let isNewProduct = false;
        let upcellProductHandle = null;
        let selectedColor = null;

        if (this.upsellProducts[i].newProductHandle) {
          isNewProduct = true;
          upcellProductHandle = this.upsellProducts[i].newProductHandle;
        } else {
          const upcellProduct = this.upsellProducts[i].product;
          selectedColor = this.upsellProducts[i].selectedColor;

          let colorAvailable = false;
          const colorOption = upcellProduct.options.find(o => o.name.toLowerCase() == 'color');

          // Check if upsellProduct having selected color
          if (colorOption) {
            // const colorName = selectedColor.split("-").pop().trim();

            // if (colorOption.values.includes(colorName) || colorOption.values.some(c => {
            //   const lastPart = c.split("-").pop().trim();
            //   return lastPart == colorName;
            // })) {
            if (matchedSplitedColorNames(colorOption.values, selectedColor)) {
              colorAvailable = true;
              upcellProductHandle = upcellProduct.handle;
            }
          }
        }

        if (upcellProductHandle) {
          console.log(`https://www.godsloveovercomes.com/products/${upcellProductHandle}?view=card-upsell`);
          
          fetch(`https://www.godsloveovercomes.com/products/${upcellProductHandle}?view=card-upsell`)
          .then(resp => resp.text())
          .then(productCardHtml => {

            // debugger;

            // Add color name to parent wrapper so that this will availble to select color for product
            const upsellProductWrapper = `<div class="h-full" x-data="{ selectedHoodieColor: '${selectedColor}' }">${productCardHtml}</div>`;
            document.getElementById('sku_match_upsell_products_product_'+(i+1)).innerHTML = upsellProductWrapper;

            this.loadedUpsellProductIndexes.push(i+1);
            this.reinitializeSlider();
          });
        } else {
          document.getElementById('sku_match_upsell_products_product_'+(i+1)).innerHTML = '';
        }
      }

      this.isNewProductLoaded = this.isNewProducts;
    },
    get cartItems() {
      return Alpine.store('cart').cartItems;
    },

    get cartItemsLength() {
      return Alpine.store('cart').cartItems.length;
    },
    get isSideCartOpen() {
      return Alpine.store('cart').isSideCartOpen;
    }
  }));

  Alpine.data('colorCategory', () => ({
    categoryColorNames: [],

    init() {

      const colorSwatches = this.$el.querySelectorAll('label.colorswatch')

      colorSwatches.forEach((colorSwatche, index) => {
        const colorName = colorSwatche.getAttribute('alt');

        if (colorName) {
          this.categoryColorNames.push(colorName);
        }
      })
    },

    get shouldShowSelectedColor() {
      if (!this.categoryColorNames) {
        return false;
      }
      const selectedColor = this.selectedOptions[this.optionIndex.color + 1]
      return this.categoryColorNames ? this.categoryColorNames.includes(selectedColor) : false;
    }
  }));

  Alpine.data('bestSellers', () => ({
    bestSellterItems: [],
    bestSellterVariantIds: [],
    init() {
      fetch('https://cron.loveinfaith.work/store-backend-glo/cache/best-sellers-cached.json')
      .then(res => res.json())
      .then(data => {
        this.bestSellterItems = data;

        this.bestSellterVariantIds = this.bestSellterItems.map(i => i.variant_id.replace('gid://shopify/ProductVariant/', ''));

        this.bestSellterItems.forEach((item, itemIndex) => {
          fetch('https://www.godsloveovercomes.com/products/'+item.product_handle+'?view=card-best-sellers&variant='+item.variant_id.replace('gid://shopify/ProductVariant/', ''))
          .then(resp => {
            if (resp.status === 404) {
              throw new Error('404 Error: Resource not discovered.');
            }
            if (!resp.ok) {
              throw new Error(`Other HTTP error: ${response.status}`);
            }
            return resp.text()
          })
          .then(productCardHtml => {
            document.querySelector('#best_seller_products')
              .insertAdjacentHTML('beforeend', '<li style="order: '+itemIndex+'" class="list-none collection-product-tile">'+productCardHtml+'</li>');

          }).catch(error => {
            // Intercepts both the manually thrown 404 error and standard network losses
            console.error('Error encountered:', error.message);
          });
        });
      });

    }
  }));

  Alpine.data('buyOneGetOneOffer', () => ({
    atcInProgress: false,
    showAddedAnimation: false,

    init() {
      if (Alpine.store('buyOneGetOneOffer').isActive) {

        setTimeout(() => {
          this.initSlider();
        }, 2000);
      }

      this.$watch('hoodieProductQtys', async (newQtys, prevQty) => {
        if (this.hoodieProductQtys < this.freeProductQtys) {
          console.log('Should delete free product here 1111.');

          const totalDeleteQtys = this.freeProductQtys - this.hoodieProductQtys;

          const freeItems = Alpine.store('cart').cartItems.filter((i) => i.properties.attributes.__buy1_get1_offer);

          Alpine.store('cart').isCartQtyInProgress = true;

          let deletedQtys = 0;

          for (const freeItem of freeItems) {
            const freeItemQty = parseInt(freeItem.quantity, 10);

            // Check if delete qty is not fulfilled
            if (deletedQtys < totalDeleteQtys) {
              const shoudlDeleteQty = totalDeleteQtys - deletedQtys;
              if (freeItemQty <= shoudlDeleteQty) {

                // Delete item
                await Alpine.store('cart').removeItem(freeItem.key);
                deletedQtys += freeItemQty;
              } else {
                const partialQty = freeItemQty - shoudlDeleteQty;

                await Alpine.store('cart').updateItemQtys({ [freeItem.key]: partialQty });
                deletedQtys += partialQty;
              }
            }
          }

          Alpine.store('cart').isCartQtyInProgress = false;
        }
      });

      this.$watch('shouldAllowToAddFreeProduct', (shouldAllow) => {
        if (shouldAllow) {
          console.log('shouldAllowToAddFreeProduct: ');
          setTimeout(() => {
            this.initSlider();
          }, 1000);
        }
      });
    },
    initSlider() {
      this.mySwiper = new Swiper('.product-slider', {
        loop: false,
        slidesPerView: 1.5,
        spaceBetween: 8,
        speed: 500,
        autoplay: false,
        currentIndex: 0,
        navigation: {
          // nextEl: '.swiper-button-next-kingdom-media-gallary',
          // prevEl: '.swiper-button-prev-kingdom-media-gallary'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    },
    get freeProductQtys() {
      return Alpine.store('buyOneGetOneOffer').freeProductQtys;
    },

    get hoodieProductQtys() {
      return Alpine.store('buyOneGetOneOffer').hoodieProductQtys;
    },

    get shouldAllowToAddFreeProduct() {
      return Alpine.store('buyOneGetOneOffer').shouldAllowToAddFreeProduct;
    }
  }));
});